import { UploadCloud02 } from "@untitledui/icons";
import type { HTMLAttributes } from "react";
import { cx } from "@/utils/cx";

interface IllustrationProps extends HTMLAttributes<HTMLDivElement> {
	size?: "sm" | "md" | "lg";
	svgClassName?: string;
	childrenClassName?: string;
}

export const DocumentsIllustration = ({
	size = "lg",
	...otherProps
}: IllustrationProps) => {
	const Pattern = sizes[size];

	return <Pattern {...otherProps} />;
};

export const sm = ({
	className,
	svgClassName,
	childrenClassName,
	children = <UploadCloud02 className="size-6" />,
	...otherProps
}: Omit<IllustrationProps, "size">) => (
	<div {...otherProps} className={cx("relative h-30 w-40.25", className)}>
		<svg
			className={cx("size-full stroke-inherit text-inherit", svgClassName)}
			fill="none"
			viewBox="0 0 175 183"
		>
			<path
				d="M37.7696 4.22484L9.40355 50.252C7.61939 53.1388 9.70425 56.8674 13.1022 56.8674H69.8343C73.2322 56.8674 75.307 53.1388 73.5329 50.252L45.1568 4.22484C43.4629 1.47844 39.4636 1.47844 37.7696 4.22484Z"
				stroke="#0080FE"
				strokeMiterlimit="10"
				strokeWidth="4.33"
			/>
			<path
				d="M41.4582 41.5217C40.5561 41.5217 39.8143 40.8 39.7843 39.8979L38.822 16.7039C38.7819 15.2204 39.9747 13.9875 41.4582 13.9875C42.9416 13.9875 44.1344 15.2104 44.0943 16.7039L43.1321 39.8979C43.112 40.8 42.3703 41.5217 41.4582 41.5217Z"
				fill="#0080FE"
			/>
			<path
				d="M41.4581 49.9112C43.0082 49.9112 44.2647 48.6546 44.2647 47.1046C44.2647 45.5546 43.0082 44.2981 41.4581 44.2981C39.9081 44.2981 38.6516 45.5546 38.6516 47.1046C38.6516 48.6546 39.9081 49.9112 41.4581 49.9112Z"
				fill="#0080FE"
			/>
			<path
				d="M73.3841 44.9687C76.0598 43.9439 78.8598 42.3918 81.4442 41.0801C85.52 39.0342 89.5841 36.9656 93.6366 34.8743L130.755 16.0697L143.634 9.55882C145.329 8.69664 150.659 5.61152 152.174 5.77982C153.156 6.71081 152.827 13.7531 152.824 15.4564C154.116 14.7491 157.999 12.4613 159.285 12.5328C160.27 13.0349 160.169 13.8819 160.131 14.8944C160.04 17.3282 160.152 19.8304 160.005 22.2568C161.352 21.5781 165.44 19.2147 166.6 19.3806C166.928 19.6237 167.236 19.893 167.231 20.3552C167.205 22.8734 167.33 26.916 167.135 29.2713C168.286 28.7041 173.376 25.8802 174.112 26.0129C174.563 26.3853 174.755 26.9112 174.779 27.4868C175.015 33.166 174.709 38.8674 174.658 44.547C174.603 50.3802 174.852 56.2324 174.892 62.0723C175.055 64.0801 174.951 68.2138 174.959 70.3914L174.994 87.1009L174.98 107.432C174.976 110.077 175.149 117.812 174.544 120.041C173.494 120.892 166.737 124.183 165.133 124.996L143.306 136.081L90.2501 163.031C78.4641 169.024 66.6572 175.005 54.8372 180.932C54.3095 181.171 51.1646 182.639 50.6947 182.575C49.2378 182.378 44.8436 178.17 43.7711 177.235L31.7062 166.595L2.54496 141.345C1.85491 140.746 0.0572384 139.282 0 138.451C1.05293 137.163 24.7772 125.24 28.1887 123.113C28.0881 117.057 28.1616 110.878 28.1179 104.804L27.8435 69.1625C27.8354 66.8109 27.8424 64.6897 28.6884 62.4535C28.8709 61.9705 29.0303 61.6189 29 61.165C29.5 60.665 29.851 61.3405 29.5 60.665C30.851 59.8405 29.399 60.6588 30.3966 59.2813C31.527 57.7204 33.3953 56.7317 35.0141 55.7212L35.998 55.7044C36.4232 55.2119 39.9259 53.4931 40.7245 53.0889C46.0613 50.3622 51.4127 47.664 56.7784 44.9941L62.2553 42.2045C62.908 41.8683 63.5549 41.6692 64.143 41.2444C65.7809 40.6851 66.834 40.3712 68.6213 40.8715C68.9977 40.9768 69.6735 41.2882 69.9705 41.3529C71.1607 42.5753 72.0934 43.9334 73.3841 44.9687Z"
				fill="#007BF4"
			/>
			<path
				d="M73.5 46.1649C76.1685 45.1419 79.2276 42.3284 81.805 41.019C85.8698 38.9766 89.9229 36.9116 93.9644 34.8239L130.982 16.0519L143.827 9.55226C145.517 8.69158 150.833 5.6118 152.343 5.77981C153.323 6.70919 152.995 13.7393 152.992 15.4396C154.28 14.7335 158.153 12.4497 159.435 12.5211C160.417 13.0224 160.317 13.8678 160.279 14.8787C160.188 17.3082 160.3 19.806 160.154 22.2283C161.497 21.5507 165.574 19.1914 166.73 19.357C167.058 19.5997 167.364 19.8685 167.36 20.3299C167.334 22.8438 167.458 26.8794 167.264 29.2307C168.412 28.6645 173.488 25.8454 174.222 25.9778C174.672 26.3496 174.863 26.8746 174.887 27.4492C175.122 33.1186 174.817 38.8101 174.766 44.4799C174.712 50.303 174.96 56.145 175 61.9749L174.847 62.139L174.377 61.5791L174.172 61.651C173.591 63.173 174.219 68.5324 173.971 70.7043C173.79 68.7792 173.869 66.8226 173.812 64.8938C173.45 52.4419 173.707 39.9939 173.714 27.555C170.947 28.8199 166.714 31.1569 163.89 32.6006L146.077 41.6104L95.9925 66.8973L64.8941 82.5896L55.4967 87.2722C54.1542 87.933 51.9544 88.8791 50.779 89.5963C50.7429 90.2897 50.7151 91.5929 50.6217 92.2353L50.8143 132.955L50.9359 148.462C50.9452 149.947 51.0832 154.64 50.9385 155.934C50.7426 158.087 51.1506 166.486 50.5349 167.763C50.4664 166.469 50.4796 158.528 50.2813 158.15C50.1678 159.048 50.2229 161.356 50.2269 162.321L50.264 169.768C48.0287 171.083 46.6642 171.713 44.2398 172.655C43.9873 167.224 44.0609 160.896 44.0471 155.4L43.9244 126.658C43.8881 123.585 43.8779 120.511 43.8943 117.437C43.8956 116.283 43.9444 113.124 43.7822 112.089C43.3868 113.968 43.7084 119.277 43.7197 121.431C43.7332 123.994 43.8118 126.576 43.7347 129.136C43.6792 130.979 43.4566 132.804 43.4475 134.65C43.4376 136.661 44.206 149.299 43.337 150.148C42.8717 150.26 42.4106 150.253 42.187 150.729C42.6456 150.658 42.7892 150.589 43.1866 150.775C43.3232 151.394 43.2344 153.506 43.2374 154.275C43.2475 156.903 43.1532 159.546 43.2618 162.174C41.1932 163.016 39.8717 164.125 37.2559 165.057C36.9955 161.858 37.1198 156.772 37.1017 153.4L36.9082 130.678C36.8896 126.56 37.0595 120.867 36.7905 116.927C36.6684 118.271 36.683 119.8 36.7097 121.163C36.8387 127.737 36.5633 134.279 36.5162 140.847C36.5122 141.413 36.5254 141.976 36.4975 142.541C35.8659 142.727 35.1483 142.873 34.6751 143.309L34.5623 143.664L36.2717 143.11C36.2185 147.039 36.2246 150.969 36.29 154.897C34.4924 155.42 32.1841 156.861 30.1974 157.617C30.1814 157.479 30.1682 157.34 30.1577 157.2C29.9842 155.12 30.0516 152.425 30.0383 150.297L29.9618 139.524L29.8796 107.36L29.7783 78.6121C29.7565 75.3334 29.7695 72.0547 29.8174 68.7763C29.9111 63.9527 29.6582 62.8849 32.9568 59.0143C33.0693 58.717 33.1044 58.4613 33.3577 58.3009C34.8229 57.3734 36.5297 56.5379 38.0727 55.7572C41.0889 54.2641 44.0864 52.7341 47.0648 51.1672C47.8522 50.7501 48.7067 50.2934 49.5268 49.9191C49.7461 49.8191 49.7086 49.6352 49.7361 49.3995C49.5717 49.289 49.4363 49.1902 49.2133 49.3072C45.2144 51.4054 41.1285 53.359 37.1683 55.5449C36.9716 55.6535 36.6983 55.6491 36.4817 55.618C36.9058 55.1263 40.399 53.4105 41.1955 53.007C46.5178 50.285 51.8547 47.5914 57.2059 44.9262L62.668 42.1415C63.3189 41.8058 63.964 41.6071 64.5506 41.183C66.1841 40.6247 66.2175 41.642 68 42.1415C66.9832 43.4722 69.2038 44.1004 69.5 44.1649C70.687 45.3853 72.2128 45.1315 73.5 46.1649Z"
				fill="#FEFEFE"
			/>
			<path
				d="M32.9637 58.7195C34.2092 57.7875 36.4293 56.7248 37.8767 55.9849L45.1127 52.2901L58.4048 45.5566C60.869 44.3149 63.4882 42.933 65.9043 41.8963C69.6122 40.3058 70.7392 44.4545 73.2016 45.8203C73.5951 46.0386 74.4984 45.9994 74.9554 45.7688C77.1116 44.6806 79.3201 43.5218 81.4683 42.4144L95.0324 35.4442L135.532 14.7835C140.717 12.1823 146.295 9.06613 151.531 6.67529C151.563 9.63793 151.545 12.6009 151.48 15.5629C150.988 15.9133 150.392 16.2231 149.858 16.5199C149.748 14.5701 149.808 12.4964 149.829 10.5353C149.252 10.7285 149.01 10.8459 148.476 11.1166C148.897 11.5266 148.796 11.3085 148.816 11.9486C149.188 12.6548 148.983 16.3227 148.951 17.2964C146.558 18.0976 144.512 19.2926 142.269 20.4442L133.703 24.802L97.1368 43.4445L54.3408 65.1488C49.9969 67.3948 44.3059 69.9236 40.2362 72.2969C41.1848 72.5064 41.4162 71.8282 41.9691 72.0405L42.0187 72.366C41.4296 72.9648 41.1233 72.8502 40.9487 73.4627C39.8208 74.0091 37.7592 74.9065 36.8003 75.5309C36.5107 85.4012 37.0191 95.8049 36.8318 105.704C36.7722 108.851 37.0433 114.295 36.8057 117.161C36.6833 118.516 36.698 120.059 36.7247 121.435C36.854 128.069 36.578 134.67 36.5308 141.299C36.5268 141.869 36.5401 142.438 36.512 143.008C35.8791 143.196 35.1599 143.343 34.6857 143.783L34.5727 144.141L36.2857 143.583C36.2325 147.547 36.2386 151.512 36.3041 155.477C34.5026 156.004 32.1893 157.458 30.1984 158.222C30.1823 158.082 30.169 157.942 30.1585 157.801C29.9847 155.702 30.0522 152.982 30.0388 150.834L29.9622 139.963L29.8798 107.506L29.7783 78.496C29.7565 75.1874 29.7695 71.8788 29.8175 68.5705C29.9114 63.7029 29.658 62.6254 32.9637 58.7195Z"
				fill="#FEFEFE"
			/>
			<path
				d="M32.9637 58.7195C34.2092 57.7875 36.4293 56.7248 37.8767 55.9849L45.1127 52.2901L58.4048 45.5566C60.869 44.3149 63.4882 42.933 65.9043 41.8963C69.6122 40.3058 70.7392 44.4545 73.2016 45.8203C73.5951 46.0386 74.4984 45.9994 74.9554 45.7688C77.1116 44.6806 79.3201 43.5218 81.4683 42.4144L95.0324 35.4442L135.532 14.7835C140.717 12.1823 146.295 9.06613 151.531 6.67529C151.563 9.63793 151.565 13.703 151.5 16.665C151.008 17.0153 149.534 17.8682 149 18.165C148.89 16.2152 148.979 13.1261 149 11.165C148.423 11.3581 147.534 11.8943 147 12.165L65.3083 53.5494C56.6079 57.9706 47.8517 62.3136 39.1631 66.752C37.4244 67.6402 33.107 69.5581 31.8205 70.4516C31.6913 71.1357 31.8137 77.1967 31.8226 78.1555L31.9966 97.8861L32.2465 129.557L32.2865 139.559C32.2914 140.914 32.3346 142.939 32.5 144.165C33.2241 143.914 33.9213 143.509 34.5985 143.157L36.3115 142.598C36.2583 146.563 36.2386 151.512 36.3041 155.477C34.5026 156.004 32.1893 157.458 30.1984 158.222C30.1823 158.082 30.169 157.942 30.1585 157.801C29.9847 155.702 30.0522 152.982 30.0388 150.834L29.9622 139.963L29.8798 107.506L29.7783 78.496C29.7565 75.1874 29.7695 71.8788 29.8175 68.5705C29.9114 63.7029 29.658 62.6254 32.9637 58.7195Z"
				fill="#007BF4"
			/>
			<path
				d="M32.2073 144.691C32.0429 143.468 32.0988 140.63 32.0939 139.278L32.0542 129.303L31.8058 97.719L31.6328 78.0422C31.6239 77.0859 31.5022 71.0414 31.6307 70.3592C32.9096 69.4681 37.2017 67.5554 38.9301 66.6697C47.5677 62.2434 56.2724 57.9122 64.9217 53.5029L149.5 10.665C149.918 11.0739 147.919 11.377 147.938 12.0154C132.661 19.5638 117.196 27.7056 101.998 35.4888L32.1587 70.9846L32.5159 114.958C32.6141 121.181 32.6547 127.405 32.6376 133.628C32.6498 136.753 32.8375 140.956 32.6229 143.954C33.8973 143.43 34.9213 142.81 36.0616 142.329L35.7115 97.2306L35.6468 82.4225C35.6388 80.0661 35.5255 77.642 35.6763 75.3488C36.5557 74.9344 39.3569 73.3649 39.9969 73.1994C40.9399 73.4084 40.9503 72.4534 41.5 72.665L42 72.165C42 72.665 41.6736 72.5542 41.5 73.165C40.3787 73.71 37.4533 75.0424 36.5 75.665C36.2122 85.5086 36.7987 95.6435 36.6125 105.516C36.5533 108.654 36.8227 114.084 36.5865 116.941C36.4649 118.293 36.4795 119.832 36.5061 121.204C36.6345 127.82 36.3602 134.403 36.3133 141.014C36.3093 141.582 36.3225 142.15 36.2946 142.718C35.6654 142.906 34.9504 143.052 34.479 143.491L34.3667 143.848C33.6934 144.2 32.9272 144.44 32.2073 144.691Z"
				fill="#000308"
			/>
			<path
				d="M40.3356 73.6488C41.2007 73.3253 43.2847 72.2029 44.1925 71.7423L51.7295 67.9396L78.6035 54.4308L129.505 28.7639C139.12 23.906 149.319 19.0175 158.753 13.8918C158.8 16.7452 158.664 19.8616 158.649 22.7626L156.885 23.8036C156.846 22.6739 157.219 18.7155 156.451 18.1951L155.783 18.3375L156.392 18.5222C156.232 18.8416 156.236 18.8285 155.973 19.0774C155.985 20.8604 155.954 22.6433 155.879 24.4247C154.153 25.3527 152.159 26.249 150.369 27.1511L133.913 35.406L81.332 61.9412L55.9572 74.7916C52.2395 76.6935 45.892 80.1545 42.2062 81.6758C42.1963 82.3158 42.1344 83.7831 42.195 84.358C42.4604 84.733 42.6914 85.03 42.8282 85.4841C43.4911 87.685 42.543 100.71 43.1963 102C43.2555 104.734 43.3747 109.575 43.2085 112.263C42.8109 114.15 43.1343 119.48 43.1457 121.642C43.1592 124.215 43.2382 126.807 43.1607 129.377C43.1049 131.227 42.8811 133.059 42.872 134.912C42.8621 136.931 43.6345 149.619 42.7609 150.471C42.2932 150.584 41.8296 150.576 41.6048 151.054C42.0658 150.983 42.2102 150.914 42.6097 151.1C42.747 151.722 42.6578 153.842 42.6608 154.614C42.6709 157.252 42.5761 159.905 42.6853 162.544C40.6057 163.389 39.2772 164.502 36.6474 165.438C36.3856 162.227 36.5106 157.12 36.4924 153.735L36.2978 130.924C36.2791 126.791 36.45 121.075 36.1795 117.121C36.4179 114.27 36.1459 108.854 36.2057 105.723C36.3936 95.8754 35.8836 85.5256 36.1741 75.7063C37.1361 75.0852 39.2041 74.1924 40.3356 73.6488Z"
				fill="#FEFEFE"
			/>
			<path
				d="M40.3356 73.6488C41.2007 73.3253 43.2847 72.2029 44.1925 71.7423L51.7295 67.9396L78.6035 54.4308L129.505 28.7639C139.12 23.906 149.319 19.0175 158.753 13.8918C158.8 16.7452 159.014 20.264 159 23.165L155.885 24.8036C155.846 23.6739 157.219 18.7155 156.451 18.1951L155.783 18.3375C150.57 20.8548 144.999 23.8198 139.78 26.4407L81.2672 56.5313L54.5537 69.9263L44.7799 74.8318C42.744 75.8298 40.8006 76.4723 39 77.665C38.8082 82.2906 40.1255 101.033 39 104.665L39.4977 120.637L39.4977 135.665C39.511 138.864 39.2722 148.086 39.5 151.165C40.4291 150.898 40.7647 151.298 41.5 150.665C41.961 150.594 42.6005 150.479 43 150.665C43.1373 151.287 42.997 153.394 43 154.165C43.0101 156.803 42.8908 160.527 43 163.165C41.3147 163.787 38.5 164.665 36.6474 165.438C36.3856 162.227 36.5106 157.12 36.4924 153.735L36.2978 130.924C36.2791 126.791 36.45 121.075 36.1795 117.121C36.4179 114.27 36.1459 108.854 36.2057 105.723C36.3936 95.8754 35.8836 85.5256 36.1741 75.7063C37.1361 75.0852 39.2041 74.1924 40.3356 73.6488Z"
				fill="#007BF4"
			/>
			<path
				d="M155.452 18.4021L156.057 18.5861C155.898 18.9044 155.901 18.8914 155.641 19.1394C154.582 20.0143 148.442 22.9434 146.91 23.717L125.956 34.3047L39.2843 78.0982C39.5019 84.0507 39.5236 90.185 39.5307 96.1497C39.5525 114.386 40.0096 132.71 39.8784 150.94C40.6795 150.678 41.5108 150.432 42.2693 150.069C42.5453 149.977 42.7592 149.923 42.9813 149.747C43.177 149.591 43.3235 149.108 43.3143 148.874C43.2384 146.971 43.2231 144.991 43.2044 143.095L43.0755 129.477L42.8398 101.376C42.7982 95.6953 42.6799 89.8556 42.7499 84.1869C43.0131 84.5605 43.2423 84.8564 43.3781 85.3089C44.0359 87.5019 43.0951 100.481 43.7434 101.766C43.8021 104.49 43.9204 109.314 43.7554 111.992C43.361 113.872 43.6818 119.183 43.6931 121.337C43.7066 123.902 43.7849 126.484 43.708 129.045C43.6527 130.888 43.4306 132.714 43.4216 134.561C43.4117 136.572 44.1781 149.214 43.3113 150.063C42.8472 150.176 43.223 149.689 43 150.165C42.2704 150.795 40.2169 151.641 39.295 151.907C39.069 148.839 39.218 144.191 39.2048 141.004L39.0814 120.336L38.9591 92.5957C38.9274 87.9102 38.6674 82.1372 38.8578 77.5281C40.6443 76.3397 44.2868 74.6927 46.3068 73.6982L56.0044 68.8102L82.5096 55.4631L139.574 26.4763C144.753 23.8649 150.28 20.9104 155.452 18.4021Z"
				fill="#000308"
			/>
			<path
				d="M73.4227 45.0751C76.1002 44.0476 78.9022 42.4913 81.4883 41.176C85.567 39.1245 89.6339 37.0503 93.6891 34.9533L130.832 16.0976L143.721 9.5691C145.417 8.70458 150.75 5.61108 152.266 5.77984C153.249 6.71336 152.92 13.7747 152.917 15.4827C154.209 14.7734 158.096 12.4794 159.382 12.5512C160.368 13.0547 160.267 13.9039 160.229 14.9192C160.138 17.3595 160.25 19.8685 160.103 22.3015C161.451 21.621 165.542 19.2512 166.702 19.4175C167.031 19.6613 167.339 19.9313 167.334 20.3947C167.308 22.9198 167.433 26.9734 167.238 29.3352C168.39 28.7664 173.483 25.9348 174.22 26.0678C174.671 26.4413 174.863 26.9686 174.887 27.5458C175.123 33.2404 174.817 38.9573 174.765 44.6523C174.711 50.5013 174.96 56.3694 175 62.2252L174.847 62.3901L174.375 61.8277L174.169 61.8999C173.586 63.4286 174.217 68.8119 173.968 70.9935C173.786 69.0598 173.866 67.0945 173.808 65.1571C173.444 52.6498 173.703 40.1464 173.709 27.652C170.933 28.9225 166.686 31.27 163.852 32.72L145.978 41.7701L95.7241 67.1696L64.52 82.9317L55.0907 87.6352C53.7437 88.2989 51.5363 89.2492 50.3569 89.9696C50.3207 90.6661 50.2928 91.9752 50.1992 92.6204C50.1148 91.6209 49.8994 90.4168 50.1765 89.5047C50.9225 88.6754 51.2544 89.4871 51.8473 88.4759L51.7254 88.3908C49.6703 88.5841 50.7848 91.0354 50 92.1649C49.8706 90.7264 49.1726 88.9885 50.8999 88.1251C54.4072 86.3719 57.9217 84.6301 61.4249 82.8678L82.7805 72.0738L146.348 39.9271L157.123 34.4921C158.997 33.5548 161.392 32.4911 163.128 31.451C163.182 30.4342 163.463 26.8564 163.103 26.1655L163.154 25.9283L162.533 25.7165C162.473 25.6888 162.44 25.7153 162.286 25.7173C162.93 25.4661 163.578 25.2227 164.229 24.9875C164.154 26.9313 164.116 28.8762 164.112 30.8212C164.725 30.5701 165.426 30.2627 166.043 30.0568C165.947 27.0173 166.019 23.9227 166.057 20.8775C136.126 36.4447 105.729 51.3187 75.6987 66.7082L52.1172 78.6763C49.881 79.8156 45.1723 81.8973 43.3417 83.0058C43.3056 87.3501 43.3088 91.6946 43.3512 96.0389C43.3586 96.8907 43.4412 101.734 43.3243 102.294C42.6722 101.003 43.6185 87.9704 42.9568 85.7682C42.8203 85.3139 42.5897 85.0168 42.3249 84.6416C42.2644 84.0663 42.3261 82.5983 42.336 81.9578C46.0147 80.4358 52.35 76.9728 56.0606 75.0698L81.3867 62.2123L133.867 35.6624L150.291 27.4029C152.078 26.5002 154.067 25.6034 155.79 24.675C155.865 22.8926 155.896 21.1086 155.885 19.3247C155.885 18.7743 155.5 18.6649 155 18.6649L155.79 18.1649H156.5C157.266 18.6856 156.756 22.9232 156.794 24.0535L158.555 23.0119C158.57 20.1093 158.705 16.9912 158.659 14.1362C149.243 19.2647 139.064 24.1559 129.467 29.0165L78.6634 54.6977L51.8411 68.214L44.3186 72.0189C43.4125 72.4798 36.8635 75.3412 36 75.6649C36.1749 75.0553 37.9102 74.7609 38.5 74.1649H39C38.4464 73.9537 39.9498 73.8735 39 73.6649C43.0747 71.3027 49.5284 67.8866 53.8777 65.651L96.7264 44.0471L133.337 25.4908L141.915 21.1531C144.159 20.0068 146.208 18.8174 148.604 18.0199C148.636 17.0506 148.842 13.3997 148.469 12.6968C148.45 12.0597 147.921 12.073 147.5 11.6649C148.034 11.3955 148.922 10.8572 149.5 10.6649C149.479 12.617 149.402 15.3062 149.512 17.2469C150.047 16.9515 150.643 16.6431 151.136 16.2944C151.202 13.3461 151.219 10.3968 151.188 7.44786C145.945 9.82764 140.361 12.9294 135.169 15.5185L94.6194 36.0837L81.0385 43.0218C78.8877 44.124 76.6765 45.2775 74.5177 46.3606C74.0601 46.5902 73.1556 46.6292 72.7617 46.4119C70.2962 45.0524 69.1679 40.9228 65.4554 42.5061C63.0363 43.5379 60.4139 44.9134 57.9466 46.1494L44.6381 52.8518L37.3932 56.5295C35.9441 57.266 32.247 59.2373 31 60.1649C31.1128 59.8662 32.7458 57.826 33 57.6649C34.4702 56.7333 35.9518 56.4491 37.5 55.6649C40.5265 54.1652 44.0115 52.2388 47 50.6649C47.7901 50.246 48.2776 50.4917 49.1005 50.1157C49.3205 50.0152 49.2829 49.8306 49.3105 49.5938C49.1455 49.4828 49.0097 49.3836 48.7859 49.5011C44.7734 51.6087 40.9737 53.9693 37 56.1649C36.8026 56.2741 36.2284 55.8712 36.0111 55.84C36.4366 55.3461 39.9417 53.6227 40.7409 53.2174C46.0812 50.4833 51.4363 47.7777 56.8057 45.1006L62.2863 42.3034C62.9395 41.9663 63.5868 41.7667 64.1754 41.3407C65.8144 40.7799 66.8682 40.4651 68.6567 40.9668C69.0334 41.0724 69.7096 41.3847 70.0068 41.4495C71.1978 42.6753 72.1312 44.0371 73.4227 45.0751Z"
				fill="#072643"
			/>
			<path
				d="M43.3238 82.3053C45.1536 81.1973 49.86 79.1166 52.0951 77.9779L75.665 66.0154C105.681 50.6331 136.584 35.725 166.5 20.165C166.462 23.2088 165.904 27.127 166 30.165C165.383 30.3708 164.648 30.8944 164.035 31.1453C164.039 29.2012 164.077 27.2572 164.152 25.3144C163.501 25.5494 162.854 25.7928 162.21 26.0439C152.289 31.2905 141.938 36.391 131.906 41.4694L78.0344 68.2167L55.8537 79.4651C52.897 80.9433 50.8951 82.3532 47.9821 83.9132C47.241 84.3102 45.969 84.8231 45.3405 85.2222L45.6916 135.939L45.7706 151.72C45.7771 153.719 45.6577 158.022 45.8669 159.815C46.4042 159.601 47.1696 159.328 47.6354 159.024C48.4602 158.623 48.9722 158.392 49.8366 158.093C49.7227 158.994 49.778 161.311 49.782 162.28L50 170.665C47.7582 171.985 45.9314 172.219 43.5 173.165C43.2468 167.713 43.5981 160.849 43.5843 155.331L43.4612 126.475C43.4248 123.39 43.4146 120.304 43.431 117.218C43.4323 116.058 43.4812 112.887 43.3186 111.848C43.4844 109.16 43.3655 104.318 43.3065 101.584C43.4234 101.024 43.3407 96.1837 43.3334 95.3322C43.291 90.99 43.2878 86.6475 43.3238 82.3053Z"
				fill="#007BF4"
			/>
			<path
				d="M162.026 25.632C162.18 25.6299 163 25.165 164 25.165V25.665L163.447 25.7536C162.255 26.6303 154.983 30.1935 153.134 31.1307L130.433 42.6138L45.627 85.2151C46.0907 95.1628 45.8922 106.828 45.9217 116.889L46.1567 158.862L49.5 158.165C49.0236 158.843 46.8935 158.894 46.2484 159.286C46.7528 159.313 47.0241 159.221 47.3991 159.237C46.933 159.54 46.1672 159.811 45.6297 160.026C45.4204 158.238 45.5399 153.946 45.5334 151.953L45.4544 136.216L45.1031 84.6444C45.7318 84.2465 47.0045 83.735 47.7459 83.3391C50.6603 81.7835 53.6635 80.3776 56.6216 78.9035L78.8124 67.6866L131.708 41.0143C141.745 35.9502 152.1 30.864 162.026 25.632Z"
				fill="#000308"
			/>
			<path
				d="M49.8046 90.0893C50.5996 88.9571 50.1141 88.0545 52.1961 87.8608L52.3196 87.9461C51.7189 88.9597 51.5 89.165 51 89.165C50.7192 90.0792 50.8364 90.0893 50.6499 92.1004L50.8457 133.099L50.9693 148.711C50.9787 150.206 51.119 154.931 50.9719 156.234C50.7728 158.402 51.1875 166.859 50.5617 168.144C49.3345 170.665 50.1687 158.545 49.9672 158.165C49 158.665 49.8359 158.263 49 158.665C48 159.165 47.0109 159.692 46.5 159.665C46.21 159.665 45.6736 160.131 46.1562 159.449C43.6453 159.7 49.798 157.916 50.305 157.811C50.1479 153.766 50.1948 149.267 50.1497 145.193C50.0249 137.007 49.964 128.819 49.9672 120.631C49.9489 110.501 49.7037 100.184 49.8046 90.0893Z"
				fill="#010307"
			/>
			<path
				d="M35.998 55.4591C36.2152 55.4903 36.4892 55.4948 36.6865 55.3857C40.6574 53.1918 44.7544 51.2311 48.7641 49.1252C48.9878 49.0077 49.1234 49.1069 49.2883 49.2179C49.2607 49.4544 49.7199 50.0646 49.5 50.1651C48.6776 50.5408 47.3993 50.5733 46.6097 50.992C43.6233 52.5646 40.6177 54.1003 37.5933 55.5989C36.0461 56.3824 34.3347 57.221 32.8655 58.1519C32.6115 58.3129 32.5763 58.5695 32.4636 58.868C29.156 62.7528 29.4095 63.8244 29.3156 68.6658C29.2676 71.9562 29.2546 75.2469 29.2764 78.5376L29.378 107.391L29.4604 139.673L29.5371 150.485C29.5505 152.621 29.4829 155.327 29.6568 157.414C29.6673 157.554 29.6806 157.694 29.6967 157.833C31.6887 157.073 34.0033 155.627 35.8057 155.103C35.7402 151.16 35.7341 147.216 35.7874 143.273L34.0734 143.828L34.1865 143.472C34.6609 143.035 35.3805 142.888 36.0138 142.702C36.0418 142.135 36.0286 141.569 36.0326 141.001C36.0798 134.408 36.3559 127.843 36.2266 121.245C36.1998 119.877 36.1042 116.014 36.2266 114.665C36.4964 118.619 36.407 126.661 36.4256 130.794L36.6196 153.6C36.6378 156.984 36.5131 162.09 36.7743 165.3C39.3972 164.364 40.7223 163.252 42.7964 162.406C42.6875 159.769 42.7821 157.116 42.7721 154.478C42.769 153.707 42.858 151.587 42.721 150.965C42.3226 150.779 42.1786 150.849 41.7188 150.919C42 150.336 42.721 149.9 42.721 150.071C43.5924 149.219 42.9728 136.8 42.9827 134.781C42.9918 132.928 43.215 131.097 43.2706 129.247C43.3479 126.678 43.2692 124.086 43.2556 121.514C43.2443 119.352 42.9218 114.024 43.3183 112.137C43.4809 113.176 43.432 116.347 43.4307 117.505C43.4143 120.59 43.4245 123.675 43.4608 126.76L43.5839 155.607C43.5978 161.123 43.524 167.475 43.7771 172.925C46.2081 171.98 47.5763 171.348 49.8176 170.028L49.7805 162.554C49.7765 161.585 49.6666 158.957 49.7805 158.056C51 157.665 50.0206 166.717 50.0893 168.016C50.7067 166.735 50.2976 158.304 50.494 156.143C50.6727 157.693 50.6033 160.576 50.611 162.246L50.7596 172.515C50.7932 175.168 50.739 178.57 51.1077 181.119C52.1836 180.732 54.221 179.656 55.3077 179.11L62.7215 175.382C71.3941 171.045 80.0385 166.655 88.6541 162.207L173.655 118.947C173.64 117.497 173.639 115.935 173.693 114.487C174.246 99.8546 173.765 85.217 173.86 70.6009C174.109 68.4209 173.479 63.0418 174.061 61.5143L174.267 61.4422L174.739 62.0041L174.892 61.8393C175.055 63.851 174.951 67.9927 174.959 70.1746L174.994 86.9163L174.98 107.287C174.976 109.937 175.149 117.687 174.544 119.92C173.494 120.773 166.737 124.07 165.133 124.885L143.306 135.991L90.2501 162.994C78.4641 168.998 66.6572 174.99 54.8372 180.929C54.3095 181.168 51.1646 182.639 50.6947 182.575C49.2378 182.378 44.8436 178.161 43.7711 177.225L31.7062 166.564L2.54496 141.265C1.85491 140.665 0.0572384 139.198 0 138.366C1.05293 137.075 24.7772 125.129 28.1887 122.998C28.0881 116.93 28.1616 110.739 28.1179 104.654L27.8435 68.9432C27.8354 66.5871 27.8424 64.4618 28.6884 62.2212C28.8709 61.7373 29.0303 61.6199 29 61.1651C29 60.6651 29.5 60.1651 29.5 60.1651C29.5 60.1651 29.399 60.4231 30.3966 59.0429C31.527 57.479 33.3953 56.4884 35.0141 55.476L35.998 55.4591Z"
				fill="#010307"
			/>
			<path
				d="M171.031 31.9331L171.17 31.9945C171.537 33.0103 171.073 49.0642 171.065 51.2494L171.303 96.3362C171.3 98.1452 171.621 107.874 171.06 108.735L170.842 108.744C170.295 107.299 170.65 83.9457 170.643 81.009L170.348 55.1415C170.309 47.7818 170.356 40.4219 170.489 33.0631C167.823 34.2207 165.832 35.4144 163.319 36.6659C159.964 38.3366 156.667 39.9433 153.322 41.6573L127.484 54.7768L53.0558 92.382C52.897 97.4917 53.1768 104.065 53.2024 109.344L53.5193 151.048C53.557 156.067 53.6314 161.136 53.5773 166.158C53.5729 166.587 53.566 167.037 53.1762 167.242C52.5247 166.589 52.7983 160.173 52.798 158.897L52.7635 143.35L52.3196 91.738C55.7104 90.3228 58.761 88.5734 62.0403 86.9237L79.6441 78.0496L136.673 49.204L157.967 38.4013C161.802 36.4537 167.219 33.533 171.031 31.9331Z"
				fill="#000308"
			/>
			<g clipPath="url(#clip0_4091_10535)">
				<path
					d="M148.758 112.029C147.47 112.844 146.521 113.638 145.003 114.121C133.273 120.725 121.126 126.638 109.472 133.38C107.707 134.402 107.324 134.864 105.202 135.386C103.79 135.735 100.485 136.546 99.1666 136.568C96.7721 136.611 93.561 135.507 91.0771 135.464L71.9252 124.939C71.5424 124.654 71.385 123.822 71.1256 123.352C70.5387 122.282 68.8672 119.698 68.7396 118.572C68.5099 116.528 68.7396 114.134 68.5567 112.05C69.5264 109.989 70.1984 107.806 71.1171 105.723C75.1193 103.066 79.2449 100.525 83.2896 97.9111L84.9781 96.2591C85.0887 96.0089 83.464 94.5984 83.3577 94.249C83.2683 93.96 83.2683 92.5107 83.3109 92.1743C83.3619 91.7775 84.4762 91.0313 84.7612 91.0916C84.9143 91.1261 87.0324 92.9033 87.143 93.0974C87.245 93.2828 87.245 93.4856 87.3386 93.6667L94.0586 86.5626C100.451 82.2104 107.626 79.1004 114.329 75.2529C118.565 72.846 122.397 75.8179 126.353 77.2284C128.471 76.8618 130.721 75.2184 132.873 75.9042C139.703 79.5059 146.513 83.155 153.267 86.899C154.241 88.5122 154.44 90.0694 154.67 91.9069C154.806 92.9895 154.785 94.9435 155.104 95.8838C155.24 96.285 155.891 96.574 155.989 97.0053C156.155 97.7472 155.967 99.1749 155.916 99.96C155.891 100.327 155.967 100.758 155.912 101.107C155.861 101.418 154.623 103.596 154.368 103.958C154.049 104.407 153.624 104.739 153.279 105.166C153.709 106.094 154.194 106.551 153.985 107.694C153.556 110.066 150.485 110.959 148.763 112.046L148.758 112.029ZM139.444 85.6913C138.793 85.0399 138.023 84.5137 137.237 84.0436C131.827 80.8085 125.872 78.1558 120.39 75.0199C117.523 73.9071 115.341 75.0588 112.845 76.3312C107.63 78.9926 101.927 81.9688 96.8827 84.9062C95.7853 85.5446 94.7093 86.2477 93.8204 87.1751L83.7915 97.8809C83.9744 97.9197 84.0467 97.8378 84.1743 97.7429C84.7569 97.3072 85.6969 96.2073 86.254 95.6293C89.0484 92.735 91.7364 89.7329 94.5307 86.8386L94.8667 86.7869L116.719 98.4719L111.811 111.947L112.607 112.098L117.255 99.5157C118.089 97.5574 118.888 96.8457 120.645 95.7544C126.246 92.2778 132.197 89.2498 137.938 86.032L139.448 85.6913H139.444ZM126.761 77.3405L126.978 77.5519C131.809 80.347 137.117 82.6891 141.872 85.5791C143.956 86.8473 145.845 88.6805 147.865 90.0694L153.165 87.4554C153.254 87.1535 152.684 86.8731 152.476 86.7308L132.728 76.1371C131.129 75.6626 129.092 76.728 127.518 77.1939C127.271 77.2672 127.02 77.3405 126.761 77.3405ZM123.686 76.3787V76.4736C123.746 76.4434 123.746 76.4088 123.686 76.3787ZM123.877 76.4736V76.5684C123.937 76.5383 123.937 76.5037 123.877 76.4736ZM138.938 84.2851C135.221 82.2147 131.346 80.0278 127.552 78.117C126.404 77.539 125.23 76.9955 124.018 76.5684C124.069 76.7151 124.349 76.8272 124.49 76.9049C128.671 79.2384 133.132 81.3218 137.237 83.7502C138.172 84.3024 138.912 84.9839 139.793 85.5748C140.869 86.2908 143.991 88.1111 145.118 88.5295C145.322 88.6028 145.339 88.6028 145.313 88.3785C144.284 87.8221 143.467 86.9378 142.506 86.2822C141.4 85.5274 140.082 84.9235 138.938 84.2851ZM114.155 111.684L118.608 99.3518C119.003 98.5538 119.569 97.8982 120.339 97.4582L138.291 87.4339L145.203 93.0715C145.317 93.1189 145.381 93.0542 145.466 92.9938C145.747 92.8041 147.793 90.5223 147.78 90.3454L140.09 86.0536C139.287 85.812 138.236 86.252 137.466 86.5065C131.946 89.9011 125.706 92.7437 120.305 96.2677C119.003 97.1174 118.284 97.8939 117.638 99.3259C115.826 103.329 114.699 107.892 112.951 111.947C112.9 112.141 112.93 112.076 113.045 112.042C113.232 111.981 114.108 111.74 114.159 111.684H114.155ZM96.9465 88.3785C96.9677 88.1672 96.8274 88.1758 96.6998 88.1068C96.032 87.7358 95.3345 87.4209 94.6753 87.037L84.2678 97.9844C84.1955 98.1182 84.876 98.7781 85.0206 98.9377C85.9903 100.046 87.9893 102.587 89.0909 103.255C90.0053 103.812 91.1579 104.373 92.1191 104.886C93.1356 105.429 94.2415 105.895 95.2409 106.421C96.8827 107.28 98.4393 108.354 100.166 109.061L111.616 111.8L116.443 98.7005L108.489 94.5208C108.541 94.2879 108.375 94.3224 108.239 94.249C107.877 94.0549 105.58 92.8041 105.423 92.8127L105.27 92.8903C105.257 92.6272 104.955 92.5021 104.768 92.3943C104.024 91.9629 103.169 91.6567 102.433 91.2599C101.344 90.6776 100.247 89.9658 99.1241 89.3878C98.7413 89.1894 97.2229 88.3224 96.9465 88.3828V88.3785ZM137.271 88.2836C136.815 88.5209 136.326 88.9393 135.944 89.1463C135.812 89.2196 135.51 89.2843 135.297 89.4008L131.027 91.743L133.107 100.378C133.234 100.495 133.902 99.8866 134.051 99.8004C134.527 99.5243 134.999 99.2181 135.471 98.9377C135.944 98.6573 136.488 98.3683 136.986 98.075C137.84 97.566 138.691 97.0527 139.542 96.5395C139.601 96.5049 139.742 96.4963 139.856 96.4273C141.086 95.6854 142.306 94.9262 143.523 94.1714C143.565 93.9989 143.187 91.9543 143.089 91.743C142.966 91.4798 141.396 90.2635 141.052 89.9702C140.898 89.8408 140.656 89.7804 140.588 89.72C140.575 89.7114 140.567 89.5259 140.452 89.431C139.878 88.9608 139.21 88.3915 138.602 87.9903C138.491 87.917 138.534 87.7444 138.185 87.7962C138.104 87.8091 137.449 88.1887 137.279 88.2793L137.271 88.2836ZM146.07 96.2505L152.888 92.2735L153.824 88.8961C153.896 88.715 153.45 87.9084 153.356 87.848C153.262 87.7876 152.037 88.3828 151.804 88.495C150.936 88.9004 148.814 89.8408 148.15 90.3584C147.746 90.6732 147.248 91.51 146.87 91.9371C146.449 92.4115 145.926 92.9378 145.42 93.2958L146.066 96.2548L146.07 96.2505ZM145.454 88.5726C145.36 88.6373 145.505 88.7063 145.551 88.7624C145.645 88.6977 145.509 88.6373 145.454 88.5726ZM154.292 91.4367C154.343 91.3548 154.126 90.0305 154.087 89.8019C154.066 89.6812 154.07 89.3361 153.93 89.3404L153.267 92.0276C153.398 91.8939 154.262 91.4885 154.292 91.4367ZM86.8197 93.175L84.7399 91.3893C84.4167 91.5057 83.5023 91.8465 83.7872 92.2692C84.1487 92.8127 84.7995 93.3777 85.178 93.9342C85.4332 94.0118 86.4837 93.2526 86.8197 93.1707V93.175ZM154.683 95.1937C154.632 94.3871 154.589 93.5503 154.496 92.748C154.475 92.5625 154.389 91.7473 154.262 91.743C154.075 91.9241 153.258 92.2821 153.284 92.5366L154.687 95.1937H154.683ZM130.831 91.9284L130.091 92.2304C130.495 95.1635 131.193 98.088 131.78 101.004C131.814 101.112 131.712 101.172 131.924 101.146C132.137 101.12 132.979 100.659 132.83 100.335L130.836 91.9284H130.831ZM145.028 93.3691L143.514 92.0276L143.799 94.042L145.028 93.3691ZM83.6001 92.4115V94.1887C84.0509 94.4431 84.7782 95.7501 85.1142 95.9226C85.2801 96.0089 85.548 95.7372 85.5735 95.6164C85.5863 95.5387 85.1014 94.2706 85.0079 94.111L83.6043 92.4158L83.6001 92.4115ZM129.789 92.5064L129.122 92.7523L130.593 102.009L131.597 101.375L129.789 92.5064ZM145.977 98.9377C147.674 97.648 150.073 96.8026 151.88 98.3597C152.123 98.1268 152.246 97.8766 152.514 97.6523C152.858 97.3676 154.662 96.3971 154.687 96.1081C154.696 96.0262 154.67 95.9442 154.64 95.8666L153.028 92.6919C152.926 92.5625 152.914 92.6574 152.833 92.6919C152.561 92.8084 152.233 93.0154 151.965 93.1664C150.043 94.2361 148.214 95.4827 146.253 96.492C146.062 97.2684 146.104 98.1354 145.972 98.942L145.977 98.9377ZM126.102 104.506L130.274 102.138L128.943 93.0844C128.569 92.9593 128.432 93.2958 128.279 93.3734C127.454 93.8004 126.71 94.2663 125.915 94.7192C125.621 94.8831 125.2 95.0125 124.873 95.198C124.545 95.3835 123.673 95.7889 123.546 96.0607C123.367 96.052 123.222 96.1211 123.069 96.1987C121.755 96.863 119.611 97.9844 118.935 99.3043C117.868 101.388 117.323 104.135 116.371 106.314L116.634 108.35C117.021 108.168 117.132 107.746 117.625 107.763C118.119 107.78 119.114 108.544 119.412 108.518C119.518 108.509 120.841 107.715 121.083 107.577C121.598 107.284 122.108 106.9 122.597 106.616C122.942 106.417 123.295 106.245 123.639 106.038C124.035 105.805 126.025 104.778 126.102 104.502V104.506ZM87.0069 93.3691C86.926 93.2828 85.531 94.0334 85.4842 94.1067C85.2631 94.4431 85.6458 94.9262 85.6799 95.2886C85.8245 95.3274 85.8372 95.2497 85.918 95.1937C86.0329 95.1117 87.0239 94.1153 87.0536 94.0377C87.1217 93.8695 86.9516 93.5718 87.0026 93.3691H87.0069ZM145.22 93.5632L132.009 101.431C131.924 101.491 131.895 101.547 131.895 101.651C131.895 102.246 132.567 103.342 132.537 104.023L145.79 96.4877C145.858 96.4446 145.866 96.3971 145.862 96.3195C145.832 95.556 145.249 94.3828 145.215 93.5632H145.22ZM155.483 96.7853C155.346 96.5998 155.215 96.4014 155.019 96.2677C154.5 96.8414 152.271 97.8119 152.152 98.5236C152.127 98.6703 152.624 99.3043 152.735 99.5243C153.292 100.646 153.492 101.905 153.458 103.161C154.156 102.462 155.044 101.888 155.61 101.073C155.529 99.8608 155.827 98.5366 155.733 97.3504C155.699 96.9104 155.661 97.0269 155.487 96.7853H155.483ZM132.158 115.065L140.252 110.558C140.528 106.883 141.953 103.109 144.416 100.378C144.624 100.145 145.705 99.2138 145.743 99.1318C145.794 99.024 145.955 96.8285 145.883 96.7336L132.677 104.411C132.622 107.97 132.333 111.52 132.158 115.065ZM113.134 128.023L113.763 127.751L141.149 112.71C141.341 112.477 141.222 111.559 141.247 111.175C141.447 107.97 142.204 105.291 143.991 102.626C145.275 100.711 147.899 98.2432 150.387 99.1232C150.566 99.1879 151.081 99.5114 151.132 99.5028C151.242 99.4812 151.804 98.6875 151.718 98.5495C151.51 98.226 150.481 97.8378 150.094 97.7947C145.517 97.2555 141.736 104.01 140.903 107.845C140.554 109.449 140.762 111.14 139.733 112.512L114.044 126.388C113.789 126.336 113.925 124.758 113.899 124.421C113.759 122.571 113.176 120.211 111.284 119.491C108.472 118.417 105.495 121.16 103.977 123.287C103.705 123.671 102.493 125.551 102.459 125.879C102.437 126.099 102.922 126.388 103.109 126.25C103.173 126.203 103.743 125.042 103.879 124.822C105.232 122.661 108.311 119.306 111.139 120.686C113.538 121.855 113.376 125.78 113.138 128.019L113.134 128.023ZM83.6001 98.075L71.4914 105.667L72.6227 110.554L83.6001 98.075ZM78.2071 112.663L88.3338 103.303L83.851 98.3683L72.8098 111.032C78.7685 114.229 84.6931 117.511 90.6305 120.755L90.9793 120.785C96.7891 117.994 102.731 115.475 108.524 112.65C109.013 112.413 109.612 112.158 110.004 111.8L100.277 109.518H99.8514C95.9682 111.692 92.1872 114.06 88.2998 116.23C87.7512 116.536 87.1302 116.972 86.5348 117.076L99.5962 109.393L88.5678 103.467L78.2071 112.654V112.663ZM153.267 103.544C153.237 101.905 153.045 100.145 151.991 98.8428C151.833 99.0585 151.387 99.4812 151.399 99.7357C151.417 100.137 151.821 100.344 151.969 100.594C152.79 101.974 152.667 103.92 152.607 105.464C153.543 104.493 154.534 103.519 154.972 102.199L153.271 103.54L153.267 103.544ZM149.256 110.903C150.847 108.828 152.118 105.326 151.285 102.725C150.91 101.556 150.051 100.693 148.771 100.758C144.641 100.965 140.843 109.329 143.331 112.521C145.139 114.841 147.946 112.615 149.26 110.903H149.256ZM131.682 101.72L119.756 108.677C120.177 109.1 121.257 109.195 121.36 109.838C121.385 110.006 121.266 110.649 121.504 110.549L132.337 104.304L131.682 101.72ZM114.742 124.758C115.665 124.326 116.562 123.826 117.455 123.334C122.244 120.686 126.986 117.938 131.784 115.311C132.09 113.008 132.158 110.631 132.248 108.293C132.256 108.065 132.341 107.858 132.35 107.629C132.384 106.624 132.32 105.606 132.345 104.601L121.866 110.623C121.802 110.821 121.491 110.834 121.479 110.851C121.398 110.942 121.551 111.83 121.172 112.128C120.972 112.283 119.964 112.633 119.701 112.654C119.335 112.684 119.012 112.503 118.697 112.585C118.106 112.741 116.766 113.746 116.179 114.091C116.005 114.194 114.984 114.634 114.946 114.69L114.742 124.753V124.758ZM72.1464 111.994C72.1761 111.964 72.3973 111.248 72.4101 111.153C72.5036 110.549 71.687 107.375 71.4573 106.598C71.4148 106.447 71.3638 106.089 71.2022 106.042L70.7343 107.327C71.1937 108.82 71.5254 110.355 71.955 111.856C71.9847 111.964 71.989 112.154 72.1464 111.994ZM69.9687 111.032C70.1601 110.843 70.5089 108.928 70.8024 108.561L70.628 107.767C70.4919 107.78 70.4791 107.91 70.4366 108.004C70.2877 108.337 69.6455 109.971 69.603 110.243C69.5732 110.442 69.6795 110.726 69.7688 110.899C69.8071 110.968 69.7986 111.201 69.9645 111.037L69.9687 111.032ZM120.892 109.687L117.715 108.056C117.379 108.073 116.069 108.966 116.604 109.286C116.766 109.38 119.263 110.243 119.437 110.26C119.99 110.316 120.398 109.855 120.892 109.687ZM116.162 108.923C116.094 108.846 115.133 109.251 115.218 109.596C115.32 109.691 116.417 109.204 116.162 108.923ZM71.0108 109.113C70.7981 109.074 70.8619 109.126 70.7981 109.234C70.6578 109.493 70.1389 110.916 70.0836 111.196C69.9007 112.15 70.9725 114.052 71.1511 115.061C71.5382 114.28 71.6828 113.37 71.9294 112.534L71.0108 109.109V109.113ZM119.475 110.554L116.375 109.415L115.175 109.868C114.691 111.218 116.307 111.015 117.055 111.61L119.475 112.374V110.549V110.554ZM119.756 110.601C119.641 110.981 119.841 111.921 119.756 112.378C120.084 112.184 120.743 112.094 121.028 111.891C121.423 111.606 120.994 110.342 121.083 109.885C120.879 109.984 119.794 110.493 119.76 110.605L119.756 110.601ZM140.201 110.938L132.154 115.398L131.967 116.407L139.478 112.361C139.635 112.245 140.256 110.994 140.201 110.933V110.938ZM69.4031 111.127C69.1862 111.071 69.2457 111.17 69.1862 111.248C69.0331 111.447 68.8289 111.856 68.8544 112.111L70.4919 116.597C70.679 116.385 70.9938 116.234 70.9002 115.907C70.4323 114.306 69.7136 112.775 69.4031 111.127ZM90.6986 121.022L72.5759 111.321C72.5334 111.378 72.2782 112.245 72.2697 112.348C72.2314 112.775 72.8907 112.831 73.1926 112.999C78.3772 115.816 83.481 118.814 88.7081 121.549C88.9208 121.661 90.3456 122.428 90.4136 122.364L90.6943 121.027L90.6986 121.022ZM118.527 112.283L115.537 111.227L114.363 111.809L114.835 114.393L118.527 112.283ZM91.3621 120.919H100.591L112.279 112.469C112.305 112.344 112.181 112.352 112.092 112.326C111.607 112.18 111.029 112.098 110.527 111.981L91.3621 120.919ZM114.172 111.994L112.666 112.434C108.698 115.462 104.517 118.253 100.617 121.333L100.162 122.648L114.554 114.63L114.627 114.462L114.172 111.99V111.994ZM72.5164 112.866L72.0528 112.758L71.1937 115.967C71.5424 116.174 71.5892 116.416 71.7381 115.95C71.8529 115.583 72.6057 112.999 72.5164 112.87V112.866ZM70.3473 118.999V117.606C70.3473 117.429 70.1814 116.942 70.2112 116.687L68.9267 113.047L68.8289 113.866C68.9948 115.51 68.9182 117.179 69.0458 118.831L69.688 119.957C69.6668 119.426 69.3308 118.999 69.2244 118.46C69.1394 118.02 69.0883 117.283 69.1224 116.834C69.1606 116.316 69.3605 116.696 69.4881 116.942L70.3515 118.995L70.3473 118.999ZM72.7163 113.146C72.6993 113.323 72.695 113.431 72.8098 113.577C72.9247 113.724 74.762 114.695 75.1108 114.893C79.7978 117.52 84.5528 120.035 89.2525 122.635C89.5715 122.7 89.6948 122.346 89.4056 122.183L72.712 113.146H72.7163ZM72.3633 114.125C72.2782 114.267 72.3463 114.414 72.4866 114.475L89.3248 123.511C89.4056 123.291 89.4397 122.981 89.2185 122.847L72.6567 113.819L72.359 114.125H72.3633ZM89.1717 123.813L72.342 114.677C72.342 114.837 72.0698 115.354 72.1506 115.445C72.1676 115.462 72.4738 115.505 72.627 115.587C78.0497 118.447 83.3279 121.613 88.7379 124.495L89.1845 124.568C89.1504 124.378 89.2483 123.942 89.1674 123.813H89.1717ZM114.078 123.658C114.125 124.132 114.044 124.663 114.078 125.146C114.537 125.211 114.533 124.525 114.554 124.141C114.657 122.485 114.627 120.712 114.648 119.055C114.669 117.666 114.661 116.26 114.597 114.876C110.204 117.455 105.746 119.927 101.302 122.415C101.093 122.843 100.872 123.274 100.685 123.71C100.443 124.283 100.192 125.344 99.9237 125.814C99.762 126.099 99.1964 126.172 98.9752 126.388C98.8944 126.47 98.333 127.441 98.6009 127.35L101.676 125.763C102.463 126.039 102.561 125.073 102.892 124.503C104.351 121.997 107.256 118.68 110.433 118.999C112.679 119.224 113.874 121.596 114.078 123.653V123.658ZM88.9761 124.874L72.0528 115.639C71.989 115.924 71.8146 116.295 72.1081 116.493C77.7903 119.431 83.2939 122.726 88.9931 125.62C88.959 125.422 89.0611 125.021 88.9718 124.874H88.9761ZM131.78 115.639L114.759 125.06L114.742 125.715L130.989 116.998C131.661 116.597 131.899 116.571 131.775 115.639H131.78ZM89.4652 126.203L71.3893 116.351C71.049 116.213 70.8704 116.657 70.6322 116.838C75.9699 119.858 81.3544 122.804 86.7474 125.72C86.8112 125.754 86.824 125.875 86.8835 125.909C87.4322 126.207 88.1212 126.38 88.6401 126.798C88.959 127.108 89.614 126.427 89.4609 126.203H89.4652ZM88.8825 127.177L70.5387 117.175C70.5472 118.434 70.5472 119.711 70.6322 120.966C70.6535 121.29 70.713 122.191 70.8662 122.364L88.9505 132.341C89.1717 132.431 89.0994 131.944 89.0951 131.81C89.0526 130.926 88.9335 130.016 88.8995 129.131C88.874 128.484 88.9463 127.824 88.8825 127.177ZM69.7816 118.232C69.7816 118.232 69.5817 118.197 69.5945 118.279C69.7433 118.542 69.8922 118.344 69.7816 118.232ZM69.7816 118.904C69.3733 118.59 69.7901 119.448 69.8752 119.383C69.8752 119.254 69.7901 119.124 69.7816 118.999L70.1601 119.142L69.8284 118.521C69.7391 118.572 69.7774 118.801 69.7816 118.904ZM70.0623 119.961C70.0751 119.78 70.0878 119.538 69.8752 119.482C69.8284 119.616 70.007 120.082 70.0623 119.961ZM70.1134 120.056V120.151C70.1729 120.121 70.1729 120.086 70.1134 120.056ZM70.4451 120.729H69.973L70.3515 121.592L70.4451 120.729ZM100.447 121.113H90.8857L90.6008 122.454L99.7365 122.847L99.8896 122.782L100.447 121.113ZM109.829 122.252C109.765 122.183 109.387 122.139 109.136 122.196C106.814 122.687 105.423 124.175 104.313 126.233C103.199 128.299 102.003 132.806 104.296 134.441C107.069 136.417 110.395 131.832 111.284 129.558C112.007 127.708 112.696 123.472 110.471 122.42C110.284 122.329 109.851 122.277 109.829 122.252ZM90.2137 122.566C90.1542 122.472 89.6991 122.381 89.6736 122.614C89.7884 123.17 89.0484 125.521 89.2312 125.814C89.2653 125.871 89.4609 125.983 89.529 126C89.7204 126.047 89.6991 125.776 89.7246 125.642C89.8097 125.228 90.3201 122.735 90.2137 122.566ZM92.1191 126.009C91.5194 126.009 90.9197 126.009 90.3201 126.009C90.2095 125.508 91.0133 122.972 90.8815 122.756C90.873 122.743 90.6178 122.648 90.5625 122.648L89.848 126.056C90.605 126.16 91.3621 126.181 92.1191 126.203C92.8124 126.22 93.5099 126.198 94.2032 126.203C95.713 126.216 97.2399 126.233 98.7455 126.155C97.41 126.043 96.0575 126.134 94.7178 126.112C94.5264 126.112 94.3435 126.017 94.2032 126.013C93.5099 126 92.8124 126.013 92.1191 126.013V126.009ZM99.1241 125.909C99.1964 125.965 99.6855 125.75 99.7365 125.62L100.825 122.648L100.021 123.032L99.1198 125.909H99.1241ZM90.605 125.814H96.5211C96.972 124.9 97.325 123.917 97.6099 122.933C95.4579 123.011 93.31 122.709 91.1664 122.782C91.1154 123.144 90.4859 125.694 90.605 125.814ZM89.6566 133.397C89.4226 132.746 88.942 132.552 88.3934 132.228C83.1322 129.14 77.2757 126.004 71.8614 123.17C71.6232 123.045 71.368 122.886 71.1043 122.838C71.3808 123.179 71.5807 123.589 71.9847 123.817C77.7945 126.703 83.4214 130.486 89.2483 133.285C89.3844 133.35 89.4992 133.432 89.6566 133.397ZM99.7876 123.032H97.9417L96.8529 125.814C97.2782 125.827 97.7035 125.802 98.1288 125.814C98.3925 125.823 98.754 126.078 98.9199 125.75L99.7876 123.028V123.032ZM114.55 125.241C114.023 125.12 113.946 126.095 114.218 126.103C114.559 126.112 114.44 125.478 114.55 125.241ZM98.082 133.397C98.1799 133.492 100.536 132.806 100.63 132.673C100.834 132.233 100.685 131.711 100.732 131.241C100.838 130.197 101.072 129.049 101.37 128.044C101.493 127.635 102.029 126.487 102.042 126.229C102.046 126.125 101.995 126.043 101.901 126.017C101.459 125.888 99.1751 127.462 98.5584 127.6L98.3415 127.859L98.082 133.402V133.397ZM102.897 126.5C102.875 126.47 102.271 126.177 102.246 126.203C101.451 128.385 100.915 130.576 100.876 132.927C100.566 133.186 98.2564 133.579 98.1756 133.695C98.1416 133.747 98.3032 134.497 98.2692 134.648C99.4345 134.433 100.591 133.984 101.727 133.596C101.74 131.858 101.821 130.262 102.271 128.579C102.356 128.256 102.986 126.625 102.897 126.5ZM98.652 126.392H89.8012C89.7416 126.392 89.3673 126.958 89.2823 127.065L98.0395 127.553C98.1161 127.566 98.1458 127.544 98.1884 127.488C98.2522 127.402 98.6945 126.44 98.652 126.397V126.392ZM97.9885 130.136C98.0182 129.373 98.1288 128.61 98.0735 127.842L89.3291 127.255C89.1334 127.242 89.2057 127.255 89.1887 127.397C89.0951 128.053 89.1589 129.382 89.1887 130.093C89.2185 130.896 89.3163 131.732 89.3886 132.53C92.2297 132.725 95.0581 133.268 97.9034 133.402C97.8651 132.47 97.9587 131.543 97.997 130.615C98.1458 130.551 98.1458 130.197 97.997 130.136H97.9885ZM97.8821 133.699L89.5672 132.729C89.4992 132.789 90.0606 133.479 90.1287 133.548C90.2818 133.695 90.3881 133.786 90.6008 133.837C93.1229 134.118 95.6663 134.515 98.1799 134.696C98.0353 134.54 97.9842 133.764 97.8864 133.699H97.8821Z"
					fill="#001A2B"
				/>
				<path
					d="M139.444 85.6915L137.934 86.0322C132.192 89.25 126.242 92.278 120.641 95.7546C118.884 96.8459 118.085 97.5619 117.251 99.5159L112.602 112.098L111.807 111.947L116.715 98.472L94.8624 86.7871L94.5264 86.8388C91.7364 89.7374 89.0441 92.7395 86.2498 95.6295C85.6926 96.2075 84.7527 97.3074 84.17 97.7431C84.0424 97.838 83.9701 97.9199 83.7872 97.8811L93.8162 87.1753C94.7051 86.2479 95.7811 85.5448 96.8784 84.9064C101.923 81.969 107.63 78.9884 112.84 76.3314C115.337 75.0589 117.519 73.9073 120.386 75.0201C125.868 78.1603 131.827 80.8087 137.232 84.0437C138.019 84.5139 138.789 85.0401 139.44 85.6915H139.444Z"
					fill="#F5FFFF"
				/>
				<path
					d="M78.2071 112.663L88.5678 103.476L99.5962 109.402L86.5348 117.084C87.1345 116.976 87.7512 116.545 88.2998 116.239C92.1872 114.069 95.9683 111.701 99.8514 109.519H100.277L110.004 111.805C109.612 112.163 109.013 112.417 108.524 112.654C102.731 115.48 96.7849 117.994 90.9793 120.79L90.6306 120.759C84.6932 117.516 78.7643 114.233 72.8099 111.037L83.851 98.3728L88.3339 103.307L78.2071 112.667V112.663Z"
					fill="#F5FFFF"
				/>
				<path
					d="M108.494 94.5209L116.447 98.7006L111.62 111.8L100.17 109.061C98.4435 108.354 96.8869 107.284 95.2452 106.422L108.498 94.5166L108.494 94.5209Z"
					fill="#0080FE"
				/>
				<path
					d="M114.742 124.758L114.946 114.695C114.984 114.634 116.001 114.199 116.179 114.095C116.766 113.75 118.102 112.745 118.697 112.59C119.012 112.508 119.335 112.689 119.701 112.659C119.965 112.637 120.972 112.288 121.172 112.133C121.551 111.835 121.398 110.942 121.479 110.856C121.496 110.839 121.802 110.826 121.866 110.627L132.345 104.606C132.32 105.611 132.384 106.629 132.35 107.634C132.341 107.862 132.256 108.069 132.248 108.298C132.158 110.64 132.09 113.013 131.784 115.316C126.982 117.947 122.244 120.695 117.455 123.339C116.562 123.831 115.665 124.331 114.742 124.762V124.758ZM131.018 106.236C130.793 106.077 128.199 107.862 127.752 108.052C127.565 108.164 127.573 109.26 127.616 109.303C127.654 109.342 127.871 109.23 127.952 109.243C128.054 109.26 128.126 109.437 128.25 109.476C128.679 109.614 129.781 108.79 130.202 108.518C130.312 108.445 130.627 108.354 130.64 108.337C130.704 108.246 130.521 107.979 130.559 107.832C130.61 107.647 130.933 107.638 131.027 107.53C131.231 107.302 131.116 106.547 131.023 106.236H131.018Z"
					fill="#0080FE"
				/>
				<path
					d="M126.761 77.3408C127.02 77.3408 127.271 77.2675 127.518 77.1942C129.092 76.7283 131.129 75.6629 132.728 76.1374L152.476 86.7311C152.684 86.8734 153.254 87.1538 153.165 87.4557L147.865 90.0697C145.845 88.6807 143.956 86.8432 141.872 85.5794C137.117 82.6894 131.809 80.3473 126.978 77.5522L126.761 77.3408Z"
					fill="#F5FFFF"
				/>
				<path
					d="M132.158 115.066C132.333 111.516 132.622 107.97 132.677 104.412L145.883 96.7339C145.955 96.8288 145.79 99.0243 145.743 99.1321C145.705 99.2141 144.628 100.146 144.416 100.379C141.958 103.109 140.533 106.883 140.252 110.558L132.158 115.066ZM144.463 98.36L143.995 98.4118C143.45 98.9423 141.643 99.5548 141.247 100.038C141.06 100.267 141.149 100.935 141.196 101.241C141.315 101.427 141.519 101.211 141.66 101.228C141.77 101.241 141.724 101.53 141.941 101.513C142.055 101.504 143.833 100.491 143.952 100.379C144.195 100.137 144.025 99.8352 144.101 99.7144C144.148 99.6411 144.437 99.6799 144.471 99.5419C144.543 99.2443 144.412 98.6965 144.467 98.3557L144.463 98.36Z"
					fill="#0080FE"
				/>
				<path
					d="M102.437 91.2602L89.0909 103.26C87.9893 102.591 85.9903 100.047 85.0206 98.9423L96.9465 88.3831C97.2272 88.3227 98.7455 89.194 99.1241 89.3881C100.247 89.9661 101.344 90.6778 102.433 91.2602H102.437Z"
					fill="#F5FFFF"
				/>
				<path
					d="M114.155 111.684C114.104 111.736 113.228 111.982 113.04 112.042C112.93 112.076 112.9 112.141 112.947 111.947C114.695 107.888 115.822 103.329 117.634 99.326C118.28 97.894 118.999 97.1176 120.3 96.2678C125.706 92.7438 131.946 89.9013 137.462 86.5066C138.232 86.2521 139.282 85.8078 140.086 86.0537L147.776 90.3455C147.789 90.5224 145.743 92.7999 145.462 92.994C145.373 93.0543 145.313 93.1147 145.198 93.0716L138.287 87.434L120.335 97.4583C119.565 97.8983 118.999 98.5539 118.603 99.3519L114.15 111.684H114.155Z"
					fill="#F5FFFF"
				/>
				<path
					d="M113.134 128.023C113.376 125.784 113.534 121.859 111.135 120.69C108.307 119.31 105.223 122.666 103.875 124.827C103.739 125.047 103.169 126.207 103.105 126.255C102.918 126.393 102.433 126.099 102.454 125.884C102.484 125.556 103.696 123.675 103.973 123.291C105.491 121.165 108.468 118.417 111.28 119.496C113.168 120.22 113.755 122.58 113.895 124.426C113.921 124.762 113.789 126.341 114.04 126.393L139.729 112.516C140.758 111.145 140.55 109.45 140.898 107.849C141.728 104.015 145.513 97.2557 150.09 97.7992C150.477 97.8466 151.506 98.2305 151.714 98.554C151.804 98.6921 151.238 99.49 151.127 99.5073C151.081 99.5159 150.562 99.1881 150.383 99.1277C147.895 98.2478 145.271 100.719 143.986 102.63C142.2 105.292 141.447 107.974 141.243 111.179C141.217 111.559 141.337 112.478 141.145 112.715L113.759 127.756L113.13 128.027L113.134 128.023Z"
					fill="#0080FE"
				/>
				<path
					d="M105.274 92.8905L92.1191 104.89C91.1579 104.377 90.0011 103.816 89.0909 103.26L102.437 91.26C103.173 91.6568 104.032 91.9631 104.772 92.3944C104.964 92.5023 105.266 92.6317 105.274 92.8905Z"
					fill="#0080FE"
				/>
				<path
					d="M105.274 92.8904L105.427 92.8128C105.585 92.8042 107.881 94.055 108.243 94.2491C108.375 94.3225 108.541 94.288 108.494 94.5209L95.241 106.426C94.2372 105.9 93.1356 105.434 92.1191 104.89L105.274 92.8904Z"
					fill="#F5FFFF"
				/>
				<path
					d="M91.3621 120.919L110.527 111.982C111.029 112.098 111.603 112.18 112.092 112.327C112.181 112.353 112.309 112.344 112.279 112.469L100.591 120.919H91.3621Z"
					fill="#F5FFFF"
				/>
				<path
					d="M88.8825 127.178C88.9463 127.825 88.8698 128.48 88.8995 129.132C88.9378 130.016 89.0526 130.926 89.0952 131.81C89.1037 131.944 89.1717 132.432 88.9506 132.341L70.8662 122.364C70.7173 122.192 70.6578 121.29 70.6323 120.967C70.5429 119.711 70.5472 118.435 70.5387 117.175L88.8825 127.178ZM88.0276 128.813L71.6488 119.845L71.2958 119.772C71.1979 119.875 71.653 122.282 71.9592 122.506C76.9609 125.12 81.8053 128.071 86.8155 130.672C87.0154 130.775 88.1425 131.392 88.236 131.293L88.0276 128.817V128.813Z"
					fill="#F5FFFF"
				/>
				<path
					d="M123.546 96.0566L121.083 107.578C120.841 107.716 119.518 108.505 119.412 108.518C119.118 108.544 118.093 107.78 117.625 107.763C117.132 107.746 117.021 108.169 116.634 108.35L116.371 106.314C117.319 104.136 117.868 101.388 118.935 99.3046C119.612 97.989 121.755 96.8632 123.069 96.199C123.222 96.1213 123.367 96.048 123.546 96.061V96.0566Z"
					fill="#0080FE"
				/>
				<path
					d="M145.22 93.5635C145.254 94.3873 145.832 95.5563 145.866 96.3197C145.866 96.3974 145.866 96.4448 145.794 96.488L132.541 104.023C132.571 103.342 131.899 102.242 131.899 101.651C131.899 101.548 131.929 101.487 132.014 101.431L145.224 93.5635H145.22Z"
					fill="#F5FFFF"
				/>
				<path
					d="M114.078 123.658C113.874 121.6 112.679 119.228 110.433 119.004C107.256 118.685 104.351 122.002 102.892 124.508C102.561 125.077 102.463 126.039 101.676 125.767L98.6009 127.354C98.333 127.441 98.8944 126.47 98.9752 126.393C99.1964 126.173 99.7621 126.099 99.9237 125.819C100.196 125.349 100.443 124.283 100.685 123.714C100.872 123.278 101.098 122.847 101.302 122.42C105.746 119.931 110.204 117.46 114.597 114.88C114.661 116.265 114.669 117.671 114.648 119.06C114.623 120.716 114.657 122.493 114.555 124.145C114.529 124.529 114.537 125.215 114.078 125.15C114.044 124.672 114.125 124.137 114.078 123.662V123.658ZM113.985 116.023C113.172 116.174 112.203 116.532 112.47 117.559C113.219 117.347 114.231 117.002 113.985 116.023Z"
					fill="#0080FE"
				/>
				<path
					d="M149.235 110.903C147.92 112.62 145.113 114.841 143.306 112.521C140.818 109.329 144.616 100.965 148.746 100.758C150.026 100.693 150.885 101.556 151.259 102.725C152.093 105.322 150.825 108.824 149.23 110.903H149.235ZM148.116 102.509C144.599 102.699 141.766 111.054 145.479 111.757C147.623 112.163 149.626 108.91 150.094 107.116C150.536 105.429 150.506 102.38 148.116 102.509Z"
					fill="#F5FFFF"
				/>
				<path
					d="M109.829 122.252C109.851 122.278 110.284 122.329 110.471 122.42C112.696 123.477 112.007 127.713 111.284 129.559C110.395 131.832 107.073 136.413 104.296 134.441C101.999 132.807 103.194 128.303 104.313 126.233C105.423 124.176 106.814 122.687 109.136 122.196C109.387 122.144 109.77 122.183 109.829 122.252ZM105.882 125.664C104.64 127.29 102.914 132.039 105.568 133.057C108.022 133.997 110.412 130.012 110.756 127.967C111.462 123.77 108.324 122.467 105.882 125.664Z"
					fill="#F5FFFF"
				/>
				<path
					d="M83.6001 98.0752L72.6227 110.554L71.4914 105.667L83.6001 98.0752Z"
					fill="#F5FFFF"
				/>
				<path
					d="M146.053 96.2507L145.407 93.2917C145.913 92.9337 146.436 92.4031 146.857 91.933C147.24 91.5059 147.733 90.6691 148.137 90.3543C148.797 89.8366 150.923 88.8963 151.791 88.4909C152.025 88.383 153.25 87.7835 153.343 87.8439C153.437 87.9042 153.879 88.7109 153.811 88.892L152.875 92.2694L146.058 96.2464L146.053 96.2507Z"
					fill="#F5FFFF"
				/>
				<path
					d="M97.9885 130.615C97.9502 131.543 97.8566 132.47 97.8949 133.402C95.0496 133.273 92.2212 132.725 89.3801 132.531C89.3078 131.728 89.2142 130.896 89.1802 130.094C89.1547 129.382 89.0909 128.053 89.1802 127.398C89.2015 127.255 89.1249 127.242 89.3206 127.255L98.065 127.842C98.1203 128.61 98.014 129.369 97.98 130.137C97.9715 130.296 97.9885 130.456 97.98 130.615H97.9885ZM97.04 130.521L90.2733 129.848L90.0436 130.003L90.4264 132.138L94.8199 132.539C95.9682 132.401 96.7678 131.655 97.04 130.521Z"
					fill="#F5FFFF"
				/>
				<path
					d="M131.682 101.72L132.337 104.304L121.504 110.549C121.266 110.649 121.385 110.002 121.36 109.838C121.257 109.195 120.177 109.104 119.756 108.677L131.682 101.72Z"
					fill="#F5FFFF"
				/>
				<path
					d="M114.172 111.995L114.627 114.466L114.554 114.634L100.162 122.653L100.617 121.337C104.517 118.258 108.698 115.467 112.666 112.439L114.172 111.999V111.995Z"
					fill="#F5FFFF"
				/>
				<path
					d="M135.944 89.1465L134.051 99.8006C133.902 99.8868 133.23 100.491 133.107 100.379L131.027 91.7431L135.297 89.401C135.51 89.2845 135.812 89.2198 135.944 89.1465Z"
					fill="#0080FE"
				/>
				<path
					d="M90.6986 121.023L90.4179 122.36C90.3498 122.424 88.925 121.657 88.7124 121.544C83.4852 118.81 78.3815 115.812 73.1969 112.995C72.8907 112.831 72.2357 112.771 72.2739 112.344C72.2825 112.24 72.5376 111.378 72.5802 111.317L90.7028 121.018L90.6986 121.023Z"
					fill="#F5FFFF"
				/>
				<path
					d="M85.0206 98.938C84.8803 98.7741 84.1998 98.1185 84.2678 97.9847L94.6753 87.0374C95.3303 87.4256 96.032 87.7361 96.6998 88.1071C96.8274 88.1761 96.972 88.1675 96.9465 88.3788L85.0206 98.938Z"
					fill="#0080FE"
				/>
				<path
					d="M145.977 98.9379C146.113 98.1313 146.066 97.2643 146.257 96.4879C148.214 95.4786 150.047 94.232 151.969 93.1623C152.237 93.0113 152.565 92.8043 152.837 92.6878C152.918 92.6533 152.931 92.5584 153.033 92.6878L154.645 95.8625C154.674 95.9401 154.7 96.0221 154.691 96.104C154.666 96.393 152.863 97.3635 152.518 97.6482C152.25 97.8725 152.127 98.1227 151.884 98.3556C150.073 96.7985 147.678 97.6482 145.981 98.9336L145.977 98.9379Z"
					fill="#0080FE"
				/>
				<path
					d="M128.275 93.3694L126.098 104.507C126.021 104.787 124.03 105.809 123.635 106.042L125.906 94.7152C126.701 94.2666 127.446 93.8007 128.271 93.3694H128.275Z"
					fill="#0080FE"
				/>
				<path
					d="M128.275 93.3693C128.424 93.2917 128.564 92.9552 128.939 93.0803L130.27 102.134L126.098 104.502L128.275 93.365V93.3693Z"
					fill="#0080FE"
				/>
				<path
					d="M140.584 89.7201L139.542 96.5353C138.691 97.0486 137.84 97.5619 136.986 98.0709L138.593 87.9905C139.201 88.3873 139.869 88.961 140.443 89.4312C140.562 89.526 140.567 89.7115 140.58 89.7201H140.584Z"
					fill="#0080FE"
				/>
				<path
					d="M90.605 125.815C90.4859 125.694 91.1154 123.145 91.1664 122.782C93.31 122.709 95.4578 123.011 97.6099 122.933C97.325 123.912 96.9762 124.9 96.5211 125.815H90.605Z"
					fill="#F5FFFF"
				/>
				<path
					d="M89.4652 126.203C89.6183 126.427 88.9633 127.109 88.6443 126.798C88.1254 126.38 87.4364 126.207 86.8877 125.91C86.8282 125.879 86.8154 125.754 86.7516 125.72C81.3587 122.8 75.9784 119.854 70.6365 116.838C70.8704 116.653 71.0533 116.213 71.3935 116.351L89.4694 126.203H89.4652Z"
					fill="#F5FFFF"
				/>
				<path
					d="M98.082 133.398L98.3415 127.855L98.5584 127.596C99.1751 127.458 101.459 125.884 101.901 126.013C101.995 126.039 102.046 126.121 102.042 126.225C102.029 126.483 101.489 127.631 101.37 128.04C101.072 129.045 100.842 130.193 100.732 131.237C100.685 131.707 100.834 132.229 100.63 132.669C100.536 132.802 98.1756 133.488 98.082 133.393V133.398Z"
					fill="#0080FE"
				/>
				<path
					d="M140.584 89.7202C140.652 89.7763 140.894 89.8367 141.047 89.9704C141.392 90.2637 142.966 91.4801 143.085 91.7432C143.182 91.9546 143.561 93.9991 143.518 94.1716C142.302 94.9265 141.077 95.69 139.852 96.4275C139.742 96.4966 139.601 96.5009 139.537 96.5397L140.579 89.7245L140.584 89.7202Z"
					fill="#0080FE"
				/>
				<path
					d="M155.483 96.7854C155.657 97.027 155.695 96.9105 155.729 97.3505C155.823 98.5367 155.525 99.8609 155.606 101.073C155.044 101.888 154.151 102.458 153.454 103.161C153.488 101.905 153.288 100.646 152.731 99.5244C152.62 99.3001 152.123 98.6704 152.148 98.5237C152.271 97.8163 154.5 96.8458 155.015 96.2678C155.21 96.4015 155.342 96.6 155.478 96.7854H155.483Z"
					fill="#0080FE"
				/>
				<path
					d="M100.447 121.113L99.8897 122.782L99.7408 122.847L90.605 122.455L90.89 121.113H100.447Z"
					fill="#F5FFFF"
				/>
				<path
					d="M124.868 95.1938L122.597 106.616C122.104 106.9 121.598 107.284 121.083 107.578L123.546 96.0565C123.673 95.7848 124.554 95.375 124.873 95.1938H124.868Z"
					fill="#0080FE"
				/>
				<path
					d="M89.1717 123.813C89.2483 123.943 89.1505 124.378 89.1887 124.568L88.7422 124.495C83.3279 121.618 78.0497 118.447 72.6312 115.588C72.4781 115.506 72.1719 115.467 72.1549 115.445C72.0741 115.355 72.3463 114.837 72.3463 114.677L89.176 123.813H89.1717Z"
					fill="#0080FE"
				/>
				<path
					d="M88.9761 124.874C89.0611 125.025 88.959 125.426 88.9973 125.621C83.2981 122.726 77.7945 119.431 72.1123 116.493C71.8189 116.295 71.9932 115.924 72.057 115.639L88.9803 124.874H88.9761Z"
					fill="#0080FE"
				/>
				<path
					d="M131.78 115.639C131.903 116.571 131.665 116.597 130.993 116.998L114.746 125.715L114.763 125.06L131.784 115.639H131.78Z"
					fill="#0080FE"
				/>
				<path
					d="M138.593 87.9949L136.986 98.0753C136.488 98.3729 135.961 98.649 135.471 98.938L137.271 88.2839C137.441 88.1933 138.096 87.8137 138.176 87.8008C138.525 87.749 138.483 87.9216 138.593 87.9949Z"
					fill="#0080FE"
				/>
				<path
					d="M135.471 98.938C135.004 99.2184 134.527 99.5246 134.051 99.8007L135.944 89.1466C136.326 88.9396 136.815 88.5212 137.271 88.2839L135.471 98.938Z"
					fill="#0080FE"
				/>
				<path
					d="M72.3633 114.125L72.661 113.819L89.2228 122.847C89.4439 122.981 89.4099 123.291 89.3291 123.511L72.4909 114.475C72.3505 114.41 72.2825 114.263 72.3675 114.125H72.3633Z"
					fill="#0080FE"
				/>
				<path
					d="M125.91 94.7151L123.639 106.042C123.295 106.249 122.942 106.417 122.597 106.62L124.868 95.1982C125.196 95.0127 125.617 94.8833 125.91 94.7194V94.7151Z"
					fill="#0080FE"
				/>
				<path
					d="M138.938 84.2853C140.082 84.9236 141.4 85.5275 142.506 86.2824C143.467 86.938 144.284 87.8222 145.313 88.3787C145.339 88.603 145.322 88.603 145.118 88.5296C143.99 88.1156 140.869 86.2953 139.793 85.575C138.912 84.9883 138.172 84.3068 137.236 83.7504C133.128 81.322 128.666 79.2386 124.49 76.905C124.349 76.8274 124.073 76.7153 124.018 76.5686C125.234 76.9956 126.404 77.5391 127.552 78.1171C131.346 80.0279 135.22 82.2105 138.938 84.2853Z"
					fill="#0080FE"
				/>
				<path
					d="M89.6565 133.398C89.4949 133.432 89.3801 133.35 89.2482 133.285C83.4257 130.486 77.7988 126.703 71.9847 123.818C71.5807 123.593 71.3808 123.179 71.1043 122.838C71.368 122.886 71.6232 123.045 71.8614 123.171C77.2756 126.004 83.1322 129.14 88.3934 132.229C88.942 132.548 89.4226 132.742 89.6565 133.398Z"
					fill="#F5FFFF"
				/>
				<path
					d="M130.831 91.9287L132.826 100.336C132.975 100.659 132.137 101.121 131.92 101.146C131.703 101.172 131.809 101.112 131.775 101.004C131.193 98.0882 130.495 95.1681 130.087 92.2306L130.827 91.9287H130.831Z"
					fill="#F5FFFF"
				/>
				<path
					d="M72.7163 113.146L89.4099 122.183C89.6991 122.347 89.5758 122.7 89.2568 122.636C84.5571 120.035 79.802 117.516 75.1151 114.893C74.7663 114.699 72.9375 113.733 72.8141 113.578C72.6908 113.422 72.7035 113.323 72.7206 113.146H72.7163Z"
					fill="#0080FE"
				/>
				<path
					d="M102.897 126.5C102.986 126.625 102.361 128.256 102.271 128.579C101.821 130.262 101.74 131.858 101.727 133.596C100.591 133.984 99.4346 134.433 98.2692 134.648C98.3032 134.497 98.1416 133.747 98.1756 133.695C98.2522 133.579 100.562 133.182 100.876 132.927C100.915 130.577 101.451 128.39 102.246 126.203C102.271 126.177 102.875 126.475 102.897 126.5Z"
					fill="#0080FE"
				/>
				<path
					d="M129.789 92.5066L131.597 101.375L130.593 102.009L129.126 92.7525L129.789 92.5066Z"
					fill="#F5FFFF"
				/>
				<path
					d="M98.652 126.393C98.6945 126.436 98.2522 127.398 98.1884 127.484C98.1458 127.54 98.1161 127.566 98.0395 127.549L89.2823 127.061C89.3674 126.953 89.7459 126.388 89.8012 126.388H98.652V126.393Z"
					fill="#F5FFFF"
				/>
				<path
					d="M97.8822 133.7C97.98 133.764 98.031 134.541 98.1756 134.696C95.662 134.515 93.1186 134.118 90.5965 133.838C90.3839 133.786 90.2775 133.695 90.1244 133.549C90.0521 133.48 89.4949 132.789 89.563 132.729L97.8779 133.7H97.8822Z"
					fill="#F5FFFF"
				/>
				<path
					d="M140.201 110.938C140.256 110.994 139.635 112.249 139.478 112.365L131.967 116.411L132.154 115.402L140.201 110.942V110.938Z"
					fill="#0080FE"
				/>
				<path
					d="M119.475 110.554V112.378L117.055 111.615C116.307 111.02 114.691 111.218 115.175 109.872L116.375 109.419L119.475 110.558V110.554Z"
					fill="#F5FFFF"
				/>
				<path
					d="M118.527 112.284L114.835 114.393L114.363 111.809L115.537 111.222L118.527 112.284Z"
					fill="#F5FFFF"
				/>
				<path
					d="M153.267 103.545L154.968 102.203C154.53 103.523 153.539 104.498 152.603 105.468C152.663 103.924 152.786 101.979 151.965 100.599C151.816 100.348 151.412 100.137 151.395 99.7403C151.382 99.4858 151.829 99.0588 151.986 98.8474C153.045 100.154 153.233 101.91 153.262 103.549L153.267 103.545Z"
					fill="#0080FE"
				/>
				<path
					d="M71.0108 109.113L71.9295 112.538C71.6828 113.375 71.5382 114.285 71.1512 115.066C70.9725 114.056 69.905 112.154 70.0836 111.201C70.1389 110.921 70.6578 109.497 70.7981 109.238C70.8577 109.126 70.7981 109.079 71.0108 109.118V109.113Z"
					fill="#F5FFFF"
				/>
				<path
					d="M99.7876 123.032L98.9199 125.754C98.7541 126.082 98.3925 125.828 98.1288 125.819C97.7035 125.806 97.2782 125.828 96.8529 125.819L97.9417 123.037H99.7876V123.032Z"
					fill="#F5FFFF"
				/>
				<path
					d="M120.892 109.687C120.398 109.855 119.99 110.312 119.437 110.261C119.263 110.243 116.766 109.381 116.604 109.286C116.069 108.967 117.379 108.074 117.715 108.056L120.892 109.687Z"
					fill="#F5FFFF"
				/>
				<path
					d="M70.3473 118.999L69.4839 116.946C69.3563 116.696 69.1564 116.321 69.1181 116.838C69.0841 117.287 69.1351 118.02 69.2202 118.465C69.3265 119.004 69.6583 119.431 69.6838 119.961L69.0416 118.836C68.914 117.179 68.9948 115.514 68.8246 113.871L68.9225 113.051L70.2069 116.692C70.1771 116.946 70.343 117.429 70.343 117.611V119.004L70.3473 118.999Z"
					fill="#F5FFFF"
				/>
				<path
					d="M72.1464 111.994C71.989 112.15 71.9847 111.96 71.955 111.856C71.5211 110.355 71.1937 108.82 70.7343 107.327L71.2022 106.042C71.368 106.089 71.4148 106.447 71.4573 106.598C71.6828 107.379 72.4994 110.549 72.4101 111.153C72.3973 111.248 72.1761 111.96 72.1464 111.994Z"
					fill="#F5FFFF"
				/>
				<path
					d="M86.8197 93.1752C86.488 93.2572 85.4332 94.0163 85.178 93.9387C84.7952 93.3823 84.1488 92.8129 83.7872 92.2737C83.5023 91.8467 84.4167 91.5103 84.7399 91.3938L86.8197 93.1795V93.1752Z"
					fill="#F5FFFF"
				/>
				<path
					d="M69.4031 111.128C69.7135 112.775 70.4323 114.302 70.9002 115.907C70.9937 116.239 70.679 116.39 70.4919 116.597L68.8544 112.111C68.8289 111.856 69.033 111.442 69.1862 111.248C69.2457 111.171 69.1862 111.071 69.4031 111.128Z"
					fill="#F5FFFF"
				/>
				<path
					d="M83.6001 92.4118L85.0036 94.1069C85.0972 94.2709 85.5863 95.5347 85.5693 95.6123C85.548 95.7331 85.2801 96.0048 85.1099 95.9186C84.7739 95.746 84.0467 94.4391 83.5958 94.1846V92.4075L83.6001 92.4118Z"
					fill="#F5FFFF"
				/>
				<path
					d="M119.756 110.601C119.79 110.489 120.875 109.98 121.079 109.881C120.989 110.338 121.419 111.602 121.023 111.887C120.743 112.09 120.079 112.184 119.752 112.374C119.837 111.921 119.637 110.977 119.752 110.597L119.756 110.601Z"
					fill="#F5FFFF"
				/>
				<path
					d="M154.666 95.1939L153.262 92.5368C153.237 92.2823 154.053 91.92 154.241 91.7432C154.372 91.7518 154.453 92.5627 154.475 92.7482C154.572 93.5505 154.611 94.3873 154.662 95.1939H154.666Z"
					fill="#F5FFFF"
				/>
				<path
					d="M90.2137 122.567C90.32 122.735 89.8097 125.228 89.7246 125.642C89.6948 125.776 89.7203 126.048 89.529 126C89.4609 125.983 89.2653 125.871 89.2312 125.815C89.0526 125.521 89.7884 123.171 89.6736 122.614C89.6991 122.381 90.1542 122.472 90.2137 122.567Z"
					fill="#F5FFFF"
				/>
				<path
					d="M99.1241 125.91L100.026 123.033L100.83 122.649L99.7408 125.621C99.6898 125.754 99.2006 125.97 99.1283 125.91H99.1241Z"
					fill="#F5FFFF"
				/>
				<path
					d="M92.1191 126.199C91.3578 126.181 90.6008 126.16 89.848 126.052L90.5625 122.644C90.6178 122.644 90.873 122.739 90.8815 122.752C91.0133 122.968 90.2095 125.504 90.3201 126.004C90.9198 126.004 91.5194 126.004 92.1191 126.004V126.199Z"
					fill="#F5FFFF"
				/>
				<path
					d="M87.0068 93.3693C86.9516 93.5764 87.1259 93.8697 87.0579 94.0379C87.0281 94.1156 86.0371 95.112 85.9223 95.1939C85.8415 95.25 85.8287 95.3276 85.6841 95.2888C85.6501 94.9265 85.2673 94.4434 85.4885 94.1069C85.5353 94.0336 86.926 93.2788 87.0111 93.3693H87.0068Z"
					fill="#F5FFFF"
				/>
				<path
					d="M72.5164 112.866C72.6057 112.995 71.8529 115.583 71.7381 115.946C71.5892 116.416 71.5467 116.17 71.1937 115.963L72.0528 112.754L72.5164 112.861V112.866Z"
					fill="#F5FFFF"
				/>
				<path
					d="M69.9687 111.033C69.8029 111.197 69.8114 110.968 69.7731 110.895C69.6838 110.722 69.5774 110.442 69.6072 110.239C69.6497 109.967 70.2877 108.337 70.4408 108C70.4834 107.906 70.5004 107.776 70.6322 107.763L70.8066 108.557C70.5131 108.923 70.1644 110.839 69.973 111.028L69.9687 111.033Z"
					fill="#F5FFFF"
				/>
				<path
					d="M145.028 93.3693L143.799 94.0422L143.518 92.0278L145.028 93.3693Z"
					fill="#F5FFFF"
				/>
				<path
					d="M154.275 91.4369C154.245 91.4886 153.381 91.8898 153.25 92.0278L153.913 89.3406C154.053 89.3406 154.053 89.6813 154.07 89.8021C154.109 90.035 154.326 91.3549 154.275 91.4369Z"
					fill="#F5FFFF"
				/>
				<path
					d="M94.2032 126.009C94.3435 126.009 94.5264 126.104 94.7178 126.108C96.0576 126.134 97.4101 126.043 98.7455 126.151C97.2357 126.229 95.7131 126.211 94.2032 126.198V126.004V126.009Z"
					fill="#F5FFFF"
				/>
				<path
					d="M94.2032 126.009V126.203C93.5099 126.198 92.8124 126.22 92.1191 126.203V126.009C92.8124 126.009 93.5099 125.996 94.2032 126.009Z"
					fill="#F5FFFF"
				/>
				<path
					d="M116.162 108.923C116.417 109.199 115.32 109.691 115.218 109.596C115.133 109.251 116.094 108.85 116.162 108.923Z"
					fill="#F5FFFF"
				/>
				<path
					d="M114.55 125.241C114.44 125.474 114.559 126.108 114.218 126.104C113.946 126.099 114.023 125.12 114.55 125.241Z"
					fill="#0080FE"
				/>
				<path
					d="M70.4451 120.729L70.3515 121.592L69.9688 120.729H70.4451Z"
					fill="#F5FFFF"
				/>
				<path
					d="M69.7816 118.905C69.7774 118.801 69.7391 118.577 69.8284 118.521L70.1601 119.142L69.7816 119C69.7816 118.969 69.7816 118.935 69.7816 118.905Z"
					fill="#F5FFFF"
				/>
				<path
					d="M70.0623 119.961C70.007 120.082 69.8284 119.616 69.8752 119.483C70.0878 119.539 70.0751 119.785 70.0623 119.961Z"
					fill="#001A2B"
				/>
				<path
					d="M69.7944 118.754C69.7944 118.81 69.7901 118.866 69.7944 118.922C69.8156 119.138 70.007 119.366 69.9985 119.595C69.8156 119.707 68.9054 118.197 69.7944 118.754Z"
					fill="#001A2B"
				/>
				<path
					d="M97.9885 130.616C97.997 130.456 97.98 130.296 97.9885 130.137C98.1373 130.201 98.1373 130.555 97.9885 130.616Z"
					fill="#001A2B"
				/>
				<path
					d="M69.7816 118.232C69.8879 118.344 69.7391 118.542 69.5945 118.279C69.5817 118.197 69.7774 118.223 69.7816 118.232Z"
					fill="#F5FFFF"
				/>
				<path
					d="M145.454 88.5728C145.505 88.6331 145.645 88.6978 145.551 88.7625C145.505 88.7065 145.36 88.6418 145.454 88.5728Z"
					fill="#0080FE"
				/>
				<path
					d="M123.877 76.4739C123.937 76.5041 123.937 76.5386 123.877 76.5688V76.4739Z"
					fill="#0080FE"
				/>
				<path
					d="M70.1133 120.056C70.1729 120.087 70.1729 120.121 70.1133 120.151V120.056Z"
					fill="#001A2B"
				/>
				<path
					d="M123.686 76.3789C123.746 76.4091 123.746 76.4436 123.686 76.4738V76.3789Z"
					fill="#0080FE"
				/>
				<path
					d="M131.018 106.236C131.112 106.547 131.227 107.306 131.023 107.53C130.929 107.634 130.606 107.647 130.555 107.832C130.517 107.979 130.699 108.251 130.636 108.337C130.623 108.358 130.308 108.445 130.198 108.518C129.781 108.79 128.679 109.614 128.245 109.476C128.118 109.437 128.05 109.26 127.948 109.243C127.871 109.23 127.65 109.337 127.612 109.303C127.569 109.256 127.561 108.164 127.748 108.052C128.194 107.862 130.789 106.077 131.014 106.236H131.018ZM130.831 106.616C130.682 106.577 130.61 106.655 130.495 106.706C130.172 106.853 128.092 108.069 127.939 108.242C127.726 108.483 127.803 108.712 127.803 109.014L130.738 107.431C130.916 107.228 130.806 106.875 130.831 106.616ZM130.359 107.962C130.291 107.897 128.875 108.699 128.688 108.811C128.539 108.902 128.228 108.988 128.279 109.208C128.445 109.234 128.573 109.195 128.726 109.135C128.939 109.048 129.908 108.475 130.108 108.328C130.185 108.272 130.47 108.065 130.359 107.962Z"
					fill="#001A2B"
				/>
				<path
					d="M144.463 98.3599C144.407 98.6963 144.539 99.2441 144.467 99.546C144.433 99.6841 144.144 99.6453 144.097 99.7186C144.02 99.8394 144.19 100.141 143.948 100.383C143.833 100.499 142.051 101.509 141.936 101.517C141.724 101.535 141.766 101.246 141.656 101.233C141.515 101.215 141.311 101.431 141.192 101.246C141.145 100.939 141.056 100.271 141.243 100.042C141.638 99.559 143.45 98.9465 143.99 98.4159L144.458 98.3642L144.463 98.3599ZM144.271 98.6489L141.451 100.202L141.43 100.948L144.25 99.3951L144.271 98.6489ZM143.799 99.8954C143.552 100.033 141.919 100.978 141.911 101.095C141.894 101.302 142.136 101.168 142.225 101.129C142.468 101.021 143.489 100.422 143.65 100.266C143.778 100.141 143.846 100.115 143.803 99.8954H143.799Z"
					fill="#001A2B"
				/>
				<path
					d="M88.0276 128.813L88.236 131.288C88.1425 131.388 87.0154 130.771 86.8155 130.667C81.8053 128.066 76.9609 125.116 71.9592 122.502C71.653 122.278 71.1979 119.871 71.2957 119.767L71.6487 119.841L88.0319 128.808L88.0276 128.813ZM72.2399 122.265C71.938 121.618 72.0358 120.656 71.5807 120.156C71.704 120.716 71.7593 121.51 71.9592 122.028C72.0145 122.174 72.0358 122.304 72.2399 122.269V122.265ZM87.8575 129.369C87.866 129.179 87.8873 128.994 87.7044 128.899L72.1464 120.44C72.1294 120.656 72.1379 120.859 72.342 120.962C77.5436 123.71 82.6346 126.677 87.8575 129.365V129.369ZM87.8575 130.232C87.8532 129.994 87.9383 129.701 87.7086 129.572C82.7962 127.079 78.0795 124.18 73.1926 121.639C71.8231 120.928 71.8146 121.286 72.9375 122.088L87.8617 130.232H87.8575ZM87.8362 130.447L72.4313 122.071C72.3335 122.558 72.8651 122.739 73.2182 122.951C77.7435 125.616 82.6559 128.135 87.2876 130.663C87.5045 130.779 87.7341 130.879 87.9511 130.995C87.9511 130.831 87.9511 130.564 87.832 130.443L87.8362 130.447Z"
					fill="#001A2B"
				/>
				<path
					d="M113.985 116.023C114.236 117.002 113.219 117.347 112.47 117.559C112.203 116.532 113.172 116.174 113.985 116.023ZM113.7 116.312C113.653 116.26 112.415 116.925 112.658 117.175C112.781 117.3 114.019 116.679 113.7 116.312Z"
					fill="#001A2B"
				/>
				<path
					d="M148.137 102.509C150.528 102.38 150.557 105.43 150.115 107.116C149.647 108.91 147.644 112.163 145.5 111.757C141.787 111.054 144.62 102.703 148.137 102.509ZM147.942 102.803C145.347 103.204 142.664 109.139 144.697 111.037C145.322 111.624 145.926 111.58 146.666 111.296C148.979 110.407 150.728 106.275 149.877 103.959C149.554 103.079 148.869 102.656 147.942 102.798V102.803Z"
					fill="#001A2B"
				/>
				<path
					d="M105.882 125.664C108.324 122.467 111.462 123.77 110.756 127.967C110.412 130.007 108.022 133.993 105.568 133.057C102.914 132.043 104.64 127.29 105.882 125.664ZM108.375 124.206C105.746 124.663 103.131 130.508 105.13 132.44C106.95 134.2 109.429 130.926 110.055 129.365C110.727 127.687 111.186 123.718 108.375 124.206Z"
					fill="#001A2B"
				/>
				<path
					d="M97.04 130.521C96.7678 131.655 95.9682 132.401 94.8199 132.539L90.4264 132.138L90.0436 130.003L90.2732 129.848L97.04 130.521ZM90.8814 130.145C90.8134 130.089 90.4561 130.158 90.3243 130.137C90.4349 130.43 90.4604 131.62 90.5582 131.771C90.6305 131.884 90.9878 131.94 91.1281 131.961C92.1234 132.099 93.5312 132.216 94.5349 132.246C95.5259 132.28 96.4233 131.784 96.6657 130.762C96.5551 130.68 96.3723 131.094 96.317 131.18C96.2447 131.297 96.2149 131.495 96.1639 131.547C96.1256 131.586 95.3813 131.94 95.2877 131.953L91.0813 131.672C91.1281 131.465 90.958 130.21 90.8814 130.145ZM96.1894 130.615L91.1749 130.232C91.277 130.464 91.2132 131.232 91.3578 131.34C91.7874 131.646 94.3478 131.504 95.007 131.75C95.6237 131.638 96.1681 131.297 96.1851 130.615H96.1894Z"
					fill="#001A2B"
				/>
				<path
					d="M130.831 106.616C130.806 106.875 130.916 107.228 130.738 107.431L127.803 109.014C127.803 108.712 127.731 108.488 127.939 108.242C128.092 108.065 130.172 106.849 130.495 106.706C130.606 106.655 130.682 106.577 130.831 106.616Z"
					fill="#F5FFFF"
				/>
				<path
					d="M130.359 107.961C130.47 108.065 130.181 108.276 130.108 108.328C129.904 108.475 128.939 109.044 128.726 109.135C128.573 109.195 128.445 109.234 128.279 109.208C128.228 108.984 128.539 108.897 128.688 108.811C128.875 108.699 130.291 107.897 130.359 107.961Z"
					fill="#0080FE"
				/>
				<path
					d="M144.254 98.6489V99.3995L141.434 100.952V100.206L144.254 98.6489Z"
					fill="#F5FFFF"
				/>
				<path
					d="M143.799 99.8955C143.842 100.115 143.774 100.141 143.646 100.266C143.489 100.422 142.464 101.021 142.221 101.129C142.132 101.168 141.894 101.306 141.906 101.095C141.915 100.978 143.548 100.029 143.795 99.8955H143.799Z"
					fill="#0080FE"
				/>
				<path
					d="M87.8575 130.232L72.9332 122.088C71.8104 121.281 71.8189 120.928 73.1884 121.639C78.0752 124.176 82.792 127.074 87.7044 129.572C87.934 129.705 87.849 129.999 87.8532 130.232H87.8575Z"
					fill="#0080FE"
				/>
				<path
					d="M87.8362 130.447C87.9511 130.568 87.9596 130.835 87.9553 130.999C87.7384 130.879 87.5087 130.784 87.2918 130.667C82.6602 128.14 77.7478 125.621 73.2224 122.955C72.8652 122.744 72.3378 122.562 72.4356 122.075L87.8405 130.452L87.8362 130.447Z"
					fill="#0080FE"
				/>
				<path
					d="M87.8575 129.369C82.6304 126.682 77.5394 123.71 72.342 120.967C72.1421 120.863 72.1294 120.656 72.1464 120.445L87.7044 128.903C87.8873 128.998 87.866 129.184 87.8575 129.373V129.369Z"
					fill="#0080FE"
				/>
				<path
					d="M72.2399 122.265C72.0358 122.304 72.0145 122.174 71.9592 122.023C71.7593 121.506 71.704 120.712 71.5807 120.151C72.0358 120.651 71.9422 121.613 72.2399 122.26V122.265Z"
					fill="#0080FE"
				/>
				<path
					d="M113.7 116.312C114.023 116.679 112.781 117.3 112.658 117.175C112.415 116.925 113.653 116.26 113.7 116.312Z"
					fill="#F5FFFF"
				/>
				<path
					d="M147.942 102.803C148.869 102.66 149.554 103.083 149.877 103.963C150.728 106.279 148.979 110.412 146.666 111.3C145.926 111.585 145.322 111.628 144.697 111.041C142.664 109.139 145.347 103.208 147.942 102.807V102.803ZM148.316 105.11C146.725 103.652 144.216 108.38 145.985 109.346C147.593 110.222 149.596 106.288 148.316 105.11Z"
					fill="#001A2B"
				/>
				<path
					d="M108.375 124.206C111.186 123.718 110.727 127.687 110.055 129.365C109.429 130.93 106.95 134.204 105.13 132.44C103.131 130.508 105.742 124.663 108.375 124.206ZM108.085 126.229C106.873 126.25 105.865 128.234 105.84 129.317C105.814 130.318 106.384 131.172 107.426 130.728C109.166 129.981 109.974 126.194 108.085 126.229Z"
					fill="#001A2B"
				/>
				<path
					d="M96.1894 130.616C96.1681 131.297 95.6237 131.642 95.0113 131.75C94.3478 131.5 91.7874 131.646 91.3621 131.34C91.2132 131.232 91.277 130.465 91.1792 130.232L96.1937 130.616H96.1894Z"
					fill="#F5FFFF"
				/>
				<path
					d="M90.8814 130.145C90.958 130.21 91.1281 131.465 91.0813 131.672L95.2877 131.953C95.3813 131.935 96.1298 131.586 96.1639 131.547C96.2149 131.495 96.2447 131.293 96.317 131.18C96.3723 131.094 96.5551 130.68 96.6657 130.762C96.4233 131.789 95.5259 132.28 94.5349 132.246C93.5312 132.211 92.1234 132.099 91.1281 131.961C90.9835 131.94 90.6305 131.888 90.5582 131.771C90.4604 131.62 90.4349 130.43 90.3243 130.137C90.4561 130.163 90.8176 130.089 90.8814 130.145Z"
					fill="#001A2B"
				/>
				<path
					d="M148.316 105.11C149.596 106.284 147.593 110.222 145.985 109.346C144.216 108.384 146.725 103.657 148.316 105.11ZM147.372 105.197C146.236 105.421 145.101 108.173 145.968 108.975C146.781 109.73 147.891 108.225 148.171 107.547C148.512 106.728 148.703 104.934 147.372 105.197Z"
					fill="#001A2B"
				/>
				<path
					d="M108.085 126.229C109.974 126.194 109.166 129.981 107.426 130.728C106.384 131.172 105.814 130.318 105.84 129.317C105.87 128.239 106.873 126.25 108.085 126.229ZM108.094 126.509C106.78 126.595 105.576 129.265 106.367 130.326C107.175 131.413 108.655 129.321 108.826 128.506C108.953 127.902 108.979 126.453 108.094 126.509Z"
					fill="#001A2B"
				/>
				<path
					d="M147.355 105.197C148.686 104.929 148.495 106.728 148.154 107.547C147.874 108.225 146.764 109.73 145.951 108.975C145.084 108.173 146.219 105.421 147.355 105.197Z"
					fill="#F5FFFF"
				/>
				<path
					d="M108.094 126.509C108.979 126.453 108.953 127.902 108.825 128.506C108.655 129.321 107.175 131.413 106.367 130.327C105.576 129.265 106.78 126.595 108.094 126.509Z"
					fill="#F5FFFF"
				/>
			</g>
			<defs>
				<clipPath id="clip0_4091_10535">
					<rect
						fill="white"
						height="62.2423"
						transform="translate(68.5567 74.3301)"
						width="87.5"
					/>
				</clipPath>
			</defs>
		</svg>
	</div>
);

export const md = ({
	className,
	svgClassName,
	childrenClassName,
	children = <UploadCloud02 className="size-7" />,
	...otherProps
}: Omit<IllustrationProps, "size">) => (
	<div {...otherProps} className={cx("relative h-34.25 w-46.25", className)}>
		<svg
			className={cx("size-full stroke-inherit text-inherit", svgClassName)}
			fill="none"
			viewBox="0 0 185 137"
		>
			<circle className="fill-utility-gray-100" cx="95" cy="64" r="64" />
			<circle className="fill-utility-gray-100" cx="29" cy="12" r="6" />
			<circle className="fill-utility-gray-100" cx="26" cy="112" r="8" />
			<circle className="fill-utility-gray-100" cx="173" cy="96" r="8" />
			<circle className="fill-utility-gray-100" cx="158" cy="9" r="5" />
			<g filter="url(#documents-shadow-01-md)">
				<path
					d="M53.9372 95.3137L93.8147 76.7185C95.8169 75.7848 96.6831 73.4049 95.7495 71.4028L72.1994 20.8995L56.2523 15.0953L23.6252 30.3095C21.6231 31.2431 20.7569 33.6231 21.6905 35.6252L48.6215 93.3789C49.5551 95.3811 51.935 96.2473 53.9372 95.3137Z"
					fill="url(#documents-gradient-01-md)"
				/>
				<path
					className="stroke-border-secondary_alt"
					d="M95.9762 71.2975C96.9679 73.4247 96.0477 75.9536 93.9206 76.9455L54.043 95.5407C51.9159 96.5326 49.3872 95.612 48.3951 93.485L21.4639 35.7309C20.4719 33.6036 21.3923 31.0749 23.5196 30.0829L56.2405 14.8249L72.3823 20.7001L95.9762 71.2975Z"
					strokeWidth="0.5"
				/>
				<path
					className="fill-utility-gray-200"
					d="M56.2523 15.0952L72.1994 20.8995L61.3237 25.9709L56.2523 15.0952Z"
				/>
			</g>
			<g filter="url(#documents-shadow-02-md)">
				<path
					d="M73 81.7241H117C119.209 81.7241 121 79.9333 121 77.7241V22L109 10H73C70.7909 10 69 11.7909 69 14V77.7241C69 79.9333 70.7909 81.7241 73 81.7241Z"
					fill="url(#documents-gradient-02-md)"
				/>
				<path
					className="stroke-border-secondary_alt"
					d="M121.25 77.7246C121.25 80.0716 119.347 81.9746 117 81.9746H73C70.6529 81.9746 68.7503 80.0716 68.75 77.7246V14C68.75 11.6528 70.6528 9.75 73 9.75H109.104L121.25 21.8965V77.7246Z"
					strokeWidth="0.5"
				/>
				<path className="fill-utility-gray-200" d="M109 10L121 22H109V10Z" />
			</g>
			<g filter="url(#documents-shadow-03-md)">
				<path
					d="M95.6253 76.6946L135.503 95.2898C137.505 96.2234 139.885 95.3572 140.819 93.3551L164.369 42.8518L158.564 26.9047L125.937 11.6905C123.935 10.7569 121.555 11.6231 120.622 13.6252L93.6906 71.3789C92.7569 73.3811 93.6232 75.761 95.6253 76.6946Z"
					fill="url(#documents-gradient-03-md)"
				/>
				<path
					className="stroke-border-secondary_alt"
					d="M141.045 93.4611C140.053 95.5881 137.524 96.5087 135.397 95.5168L95.5195 76.9216C93.3923 75.9297 92.4721 73.4009 93.4638 71.2737L120.395 13.5196C121.387 11.3923 123.916 10.4719 126.043 11.4639L158.764 26.7219L164.639 42.8637L141.045 93.4611Z"
					strokeWidth="0.5"
				/>
				<path
					className="fill-utility-gray-200"
					d="M158.564 26.9048L164.369 42.8519L153.493 37.7805L158.564 26.9048Z"
				/>
			</g>

			<defs>
				<filter
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
					height="126.98"
					id="documents-shadow-01-md"
					width="117.44"
					x="0"
					y="10.0238"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feMorphology
						in="SourceAlpha"
						operator="erode"
						radius="1.5"
						result="effect1_dropShadow_1182_2009"
					/>
					<feOffset dy="3" />
					<feGaussianBlur stdDeviation="1.5" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.04 0"
					/>
					<feBlend
						in2="BackgroundImageFix"
						mode="normal"
						result="effect1_dropShadow_1182_2009"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feMorphology
						in="SourceAlpha"
						operator="erode"
						radius="4"
						result="effect2_dropShadow_1182_2009"
					/>
					<feOffset dy="8" />
					<feGaussianBlur stdDeviation="4" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.03 0"
					/>
					<feBlend
						in2="effect1_dropShadow_1182_2009"
						mode="normal"
						result="effect2_dropShadow_1182_2009"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feMorphology
						in="SourceAlpha"
						operator="erode"
						radius="4"
						result="effect3_dropShadow_1182_2009"
					/>
					<feOffset dy="20" />
					<feGaussianBlur stdDeviation="12" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.08 0"
					/>
					<feBlend
						in2="effect2_dropShadow_1182_2009"
						mode="normal"
						result="effect3_dropShadow_1182_2009"
					/>
					<feBlend
						in="SourceGraphic"
						in2="effect3_dropShadow_1182_2009"
						mode="normal"
						result="shape"
					/>
				</filter>
				<filter
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
					height="112.724"
					id="documents-shadow-02-md"
					width="93"
					x="48.5"
					y="9.5"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feMorphology
						in="SourceAlpha"
						operator="erode"
						radius="1.5"
						result="effect1_dropShadow_1182_2009"
					/>
					<feOffset dy="3" />
					<feGaussianBlur stdDeviation="1.5" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.04 0"
					/>
					<feBlend
						in2="BackgroundImageFix"
						mode="normal"
						result="effect1_dropShadow_1182_2009"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feMorphology
						in="SourceAlpha"
						operator="erode"
						radius="4"
						result="effect2_dropShadow_1182_2009"
					/>
					<feOffset dy="8" />
					<feGaussianBlur stdDeviation="4" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.03 0"
					/>
					<feBlend
						in2="effect1_dropShadow_1182_2009"
						mode="normal"
						result="effect2_dropShadow_1182_2009"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feMorphology
						in="SourceAlpha"
						operator="erode"
						radius="4"
						result="effect3_dropShadow_1182_2009"
					/>
					<feOffset dy="20" />
					<feGaussianBlur stdDeviation="12" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.08 0"
					/>
					<feBlend
						in2="effect2_dropShadow_1182_2009"
						mode="normal"
						result="effect3_dropShadow_1182_2009"
					/>
					<feBlend
						in="SourceGraphic"
						in2="effect3_dropShadow_1182_2009"
						mode="normal"
						result="shape"
					/>
				</filter>
				<filter
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
					height="126.98"
					id="documents-shadow-03-md"
					width="117.44"
					x="72.0001"
					y="10"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feMorphology
						in="SourceAlpha"
						operator="erode"
						radius="1.5"
						result="effect1_dropShadow_1182_2009"
					/>
					<feOffset dy="3" />
					<feGaussianBlur stdDeviation="1.5" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.04 0"
					/>
					<feBlend
						in2="BackgroundImageFix"
						mode="normal"
						result="effect1_dropShadow_1182_2009"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feMorphology
						in="SourceAlpha"
						operator="erode"
						radius="4"
						result="effect2_dropShadow_1182_2009"
					/>
					<feOffset dy="8" />
					<feGaussianBlur stdDeviation="4" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.03 0"
					/>
					<feBlend
						in2="effect1_dropShadow_1182_2009"
						mode="normal"
						result="effect2_dropShadow_1182_2009"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feMorphology
						in="SourceAlpha"
						operator="erode"
						radius="4"
						result="effect3_dropShadow_1182_2009"
					/>
					<feOffset dy="20" />
					<feGaussianBlur stdDeviation="12" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.08 0"
					/>
					<feBlend
						in2="effect2_dropShadow_1182_2009"
						mode="normal"
						result="effect3_dropShadow_1182_2009"
					/>
					<feBlend
						in="SourceGraphic"
						in2="effect3_dropShadow_1182_2009"
						mode="normal"
						result="shape"
					/>
				</filter>
				<linearGradient
					gradientUnits="userSpaceOnUse"
					id="documents-gradient-01-md"
					x1="51.5944"
					x2="19.8151"
					y1="95.4694"
					y2="38.1371"
				>
					<stop className="text-utility-gray-100" stopColor="currentColor" />
					<stop
						className="text-utility-gray-50"
						offset="1"
						stopColor="currentColor"
					/>
				</linearGradient>
				<linearGradient
					gradientUnits="userSpaceOnUse"
					id="documents-gradient-02-md"
					x1="70.8109"
					x2="66.2388"
					y1="80.8751"
					y2="15.484"
				>
					<stop className="text-utility-gray-100" stopColor="currentColor" />
					<stop
						className="text-utility-gray-50"
						offset="1"
						stopColor="currentColor"
					/>
				</linearGradient>
				<linearGradient
					gradientUnits="userSpaceOnUse"
					id="documents-gradient-03-md"
					x1="94.0001"
					x2="117.492"
					y1="75"
					y2="13.8032"
				>
					<stop className="text-utility-gray-100" stopColor="currentColor" />
					<stop
						className="text-utility-gray-50"
						offset="1"
						stopColor="currentColor"
					/>
				</linearGradient>
			</defs>
		</svg>

		{children && (
			<span
				className={cx(
					"-translate-x-1/2 absolute bottom-3 left-1/2 z-10 flex size-14 items-center justify-center rounded-full bg-alpha-black/20 text-fg-white backdrop-blur-xs",
					childrenClassName
				)}
			>
				{children}
			</span>
		)}
	</div>
);

export const lg = ({
	className,
	svgClassName,
	childrenClassName,
	children = <UploadCloud02 className="size-7" />,
	...otherProps
}: Omit<IllustrationProps, "size">) => (
	<div {...otherProps} className={cx("relative h-41.5 w-57.5", className)}>
		<svg
			className={cx("size-full stroke-inherit text-inherit", svgClassName)}
			fill="none"
			viewBox="0 0 230 166"
		>
			<circle className="fill-utility-gray-100" cx="118" cy="80" r="80" />
			<circle className="fill-utility-gray-100" cx="34" cy="20" r="8" />
			<circle className="fill-utility-gray-100" cx="206" cy="126" r="6" />
			<circle className="fill-utility-gray-100" cx="33" cy="138" r="10" />
			<circle className="fill-utility-gray-100" cx="218" cy="38" r="10" />
			<circle className="fill-utility-gray-100" cx="199" cy="11" r="7" />
			<g filter="url(#documents-shadow-01-lg)">
				<path
					d="M64.0781 124.214L116.529 99.7552C119.163 98.5272 120.302 95.3969 119.074 92.7634L88.0986 26.3361L67.1232 18.7017L24.2085 38.7132C21.5751 39.9412 20.4357 43.0715 21.6637 45.7049L57.0863 121.669C58.3143 124.302 61.4446 125.442 64.0781 124.214Z"
					fill="url(#documents-gradient-01-lg)"
				/>
				<path
					className="stroke-border-secondary_alt"
					d="M119.301 92.6576C120.587 95.4162 119.394 98.6959 116.635 99.9823L64.1844 124.44C61.4258 125.727 58.1461 124.533 56.8597 121.775L21.4374 45.811C20.151 43.0524 21.3447 39.7727 24.1033 38.4864L67.1114 18.4314L67.2087 18.4668L88.1843 26.1006L88.2816 26.136L119.301 92.6576Z"
					strokeWidth="0.5"
				/>
				<path
					className="fill-utility-gray-200"
					d="M67.123 18.7017L88.0984 26.3361L73.7935 33.0066L67.123 18.7017Z"
				/>
			</g>
			<g filter="url(#documents-shadow-02-lg)">
				<path
					d="M89.1516 106.339H147.025C149.931 106.339 152.286 103.984 152.286 101.078V27.7837L136.503 12H89.1516C86.2459 12 83.8904 14.3555 83.8904 17.2612V101.078C83.8904 103.984 86.2459 106.339 89.1516 106.339Z"
					fill="url(#documents-gradient-02-lg)"
				/>
				<path
					className="stroke-border-secondary_alt"
					d="M152.537 101.078C152.537 104.122 150.069 106.59 147.025 106.59H89.1521C86.1083 106.59 83.6404 104.122 83.6404 101.078V17.2617C83.6404 14.2179 86.1083 11.75 89.1521 11.75H136.606L136.679 11.8232L152.464 27.6064L152.537 27.6797V101.078Z"
					strokeWidth="0.5"
				/>
				<path
					className="fill-utility-gray-200"
					d="M136.503 12L152.286 27.7837H136.503V12Z"
				/>
			</g>
			<g filter="url(#documents-shadow-03-lg)">
				<path
					d="M118.911 99.724L171.362 124.182C173.996 125.41 177.126 124.271 178.354 121.638L209.329 55.2103L201.695 34.2349L158.78 14.2235C156.147 12.9955 153.017 14.1348 151.789 16.7683L116.366 92.7322C115.138 95.3657 116.277 98.496 118.911 99.724Z"
					fill="url(#documents-gradient-03-lg)"
				/>
				<path
					className="stroke-border-secondary_alt"
					d="M178.581 121.743C177.295 124.502 174.015 125.696 171.256 124.409L118.805 99.9512C116.047 98.6649 114.853 95.3851 116.139 92.6265L151.562 16.6631C152.848 13.9045 156.128 12.7108 158.886 13.9971L201.894 34.0521L201.93 34.1494L209.565 55.1245L209.6 55.2219L178.581 121.743Z"
					strokeWidth="0.5"
				/>
				<path
					className="fill-utility-gray-200"
					d="M201.695 34.2349L209.329 55.2102L195.024 48.5398L201.695 34.2349Z"
				/>
			</g>

			<defs>
				<filter
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
					height="154.406"
					id="documents-shadow-01-lg"
					width="141.857"
					x="-0.559753"
					y="12.0312"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feMorphology
						in="SourceAlpha"
						operator="erode"
						radius="1.5"
						result="effect1_dropShadow_1182_2741"
					/>
					<feOffset dy="3" />
					<feGaussianBlur stdDeviation="1.5" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.04 0"
					/>
					<feBlend
						in2="BackgroundImageFix"
						mode="normal"
						result="effect1_dropShadow_1182_2741"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feMorphology
						in="SourceAlpha"
						operator="erode"
						radius="4"
						result="effect2_dropShadow_1182_2741"
					/>
					<feOffset dy="8" />
					<feGaussianBlur stdDeviation="4" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.03 0"
					/>
					<feBlend
						in2="effect1_dropShadow_1182_2741"
						mode="normal"
						result="effect2_dropShadow_1182_2741"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feMorphology
						in="SourceAlpha"
						operator="erode"
						radius="4"
						result="effect3_dropShadow_1182_2741"
					/>
					<feOffset dy="20" />
					<feGaussianBlur stdDeviation="12" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.08 0"
					/>
					<feBlend
						in2="effect2_dropShadow_1182_2741"
						mode="normal"
						result="effect3_dropShadow_1182_2741"
					/>
					<feBlend
						in="SourceGraphic"
						in2="effect3_dropShadow_1182_2741"
						mode="normal"
						result="shape"
					/>
				</filter>
				<filter
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
					height="135.339"
					id="documents-shadow-02-lg"
					width="109.396"
					x="63.3904"
					y="11.5"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feMorphology
						in="SourceAlpha"
						operator="erode"
						radius="1.5"
						result="effect1_dropShadow_1182_2741"
					/>
					<feOffset dy="3" />
					<feGaussianBlur stdDeviation="1.5" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.04 0"
					/>
					<feBlend
						in2="BackgroundImageFix"
						mode="normal"
						result="effect1_dropShadow_1182_2741"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feMorphology
						in="SourceAlpha"
						operator="erode"
						radius="4"
						result="effect2_dropShadow_1182_2741"
					/>
					<feOffset dy="8" />
					<feGaussianBlur stdDeviation="4" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.03 0"
					/>
					<feBlend
						in2="effect1_dropShadow_1182_2741"
						mode="normal"
						result="effect2_dropShadow_1182_2741"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feMorphology
						in="SourceAlpha"
						operator="erode"
						radius="4"
						result="effect3_dropShadow_1182_2741"
					/>
					<feOffset dy="20" />
					<feGaussianBlur stdDeviation="12" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.08 0"
					/>
					<feBlend
						in2="effect2_dropShadow_1182_2741"
						mode="normal"
						result="effect3_dropShadow_1182_2741"
					/>
					<feBlend
						in="SourceGraphic"
						in2="effect3_dropShadow_1182_2741"
						mode="normal"
						result="shape"
					/>
				</filter>
				<filter
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
					height="154.406"
					id="documents-shadow-03-lg"
					width="141.857"
					x="94.1425"
					y="12"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feMorphology
						in="SourceAlpha"
						operator="erode"
						radius="1.5"
						result="effect1_dropShadow_1182_2741"
					/>
					<feOffset dy="3" />
					<feGaussianBlur stdDeviation="1.5" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.04 0"
					/>
					<feBlend
						in2="BackgroundImageFix"
						mode="normal"
						result="effect1_dropShadow_1182_2741"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feMorphology
						in="SourceAlpha"
						operator="erode"
						radius="4"
						result="effect2_dropShadow_1182_2741"
					/>
					<feOffset dy="8" />
					<feGaussianBlur stdDeviation="4" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.03 0"
					/>
					<feBlend
						in2="effect1_dropShadow_1182_2741"
						mode="normal"
						result="effect2_dropShadow_1182_2741"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feMorphology
						in="SourceAlpha"
						operator="erode"
						radius="4"
						result="effect3_dropShadow_1182_2741"
					/>
					<feOffset dy="20" />
					<feGaussianBlur stdDeviation="12" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.08 0"
					/>
					<feBlend
						in2="effect2_dropShadow_1182_2741"
						mode="normal"
						result="effect3_dropShadow_1182_2741"
					/>
					<feBlend
						in="SourceGraphic"
						in2="effect3_dropShadow_1182_2741"
						mode="normal"
						result="shape"
					/>
				</filter>
				<linearGradient
					gradientUnits="userSpaceOnUse"
					id="documents-gradient-01-lg"
					x1="60.9966"
					x2="19.197"
					y1="124.418"
					y2="49.0089"
				>
					<stop className="text-utility-gray-100" stopColor="currentColor" />
					<stop
						className="text-utility-gray-50"
						offset="1"
						stopColor="currentColor"
					/>
				</linearGradient>
				<linearGradient
					gradientUnits="userSpaceOnUse"
					id="documents-gradient-02-lg"
					x1="86.2723"
					x2="80.2585"
					y1="105.223"
					y2="19.2131"
				>
					<stop className="text-utility-gray-100" stopColor="currentColor" />
					<stop
						className="text-utility-gray-50"
						offset="1"
						stopColor="currentColor"
					/>
				</linearGradient>
				<linearGradient
					gradientUnits="userSpaceOnUse"
					id="documents-gradient-03-lg"
					x1="116.773"
					x2="147.672"
					y1="97.4951"
					y2="17.0024"
				>
					<stop className="text-utility-gray-100" stopColor="currentColor" />
					<stop
						className="text-utility-gray-50"
						offset="1"
						stopColor="currentColor"
					/>
				</linearGradient>
			</defs>
		</svg>

		{children && (
			<span
				className={cx(
					"-translate-x-1/2 absolute bottom-5 left-1/2 z-10 flex size-14 items-center justify-center rounded-full bg-alpha-black/20 text-fg-white backdrop-blur-xs",
					childrenClassName
				)}
			>
				{children}
			</span>
		)}
	</div>
);

const sizes = {
	sm,
	md,
	lg,
};
